import '~/src/prismjs';
import {
  AppBar,
  Button,
  Chip,
  CircularProgress,
  Dialog,
  Grid,
  IconButton,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Toolbar,
} from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';
import { Skeleton } from '@material-ui/lab';
import i18next from 'i18next';
import { cloneDeep, isEmpty } from 'lodash';
import { MTableToolbar } from 'material-table';
import moment from 'moment';
import React, { ReactElement } from 'react';
import update from 'react-addons-update';
import { getBidderGroups, IBidderGroup } from '~/src/dash/api/bidder-group';
import {
  BrandSafetyRuleActiveActive,
  BrandSafetyRuleActiveInactive,
  BrandSafetyRuleTargetingAdomainExceptionState,
  BrandSafetyRuleTargetingAdomainExceptionStateAllowAll,
  BrandSafetyRuleTargetingAdomainExceptionStateContains,
  BrandSafetyRuleTargetingAdomainExceptionStateExactMatch,
  BrandSafetyRuleTargetingTypeBidder,
  BrandSafetyRuleTargetingTypeBidderGroup,
  BrandSafetyRuleTargetingTypeChannel,
  BrandSafetyRuleTargetingTypeChannelGroup,
  BrandSafetyRuleTargetingTypeGlobal,
  BrandSafetyTargetingTypes,
  BrandSafetyTargetingTypeToTKey,
  BrandSafetyTypeToTKey,
  getBrandSafetyTypeOptions,
  IBrandSafetyRule,
  IBrandSafetyRuleAssociationTable,
  IBrandSafetyRuleException,
  RuleTypeAdomain,
  RuleTypeCreativeID,
  RuleTypeEventTracker,
  RuleTypeIAB,
  RuleTypeLanguage,
  RuleTypeMediafile,
} from '~/src/dash/api/brand-safety-rules';
import { getChannelGroupsPromise } from '~/src/dash/api/channel-group';
import { getSmallSites } from '~/src/dash/api/channels/channels_methods';
import { ISmallSite } from '~/src/dash/api/channels/channels_models';
import {
  EAllowStatus,
  HeaderBidderActiveActive,
  IChannelGroup,
  ICountryGroup,
  IHeaderBidder,
  ISite,
  makeTargetingChangeDescription,
  makeTargetingChangeInfoHover,
  queryHeaderBidders,
  TargetingCCPAAll,
  TargetingCoppa0,
  TargetingCoppaAll,
} from '~/src/dash/api/console-api';
import {
  commonRegionGroupsIDs,
  createCountryGroup,
  deleteCountryGroup,
  getCountryGroupsByIDs,
  getCountryGroupsByPublisherID,
  updateCountryGroup,
} from '~/src/dash/api/country-group';
import {
  getCreativeValidationsV2,
  ICreativeValidation,
  REVIEW_STATUS_ALLOWED,
} from '~/src/dash/api/creative-validation';
import { createUrl, IHttpResponse, restDelete, restPatch, restPost } from '~/src/dash/api/rest';
import { EBool } from '~/src/dash/api/types/bool';
import { IAccordionPanel, MultiAccordion } from '~/src/dash/components/accordion/multi-accordion';
import { ISimpleOptionSelect } from '~/src/dash/components/common';
import ConfirmationDialogButton from '~/src/dash/components/confirmation-dialog-button';
import {
  Day,
  DaypartingSelector,
  IDaypartingInterval,
  handleAddDaypartingPeriod,
  handleDaypartingDateChange,
  handleDaypartingDayClick,
  handleDeleteDaypartingPeriod,
  parseDayparting,
  parseDaypartingIntervals,
  EDaypartingTimezonesType,
  daypartingTimezonesToTKey,
} from '~/src/dash/components/dayparting-selector';
import { ISelectOption } from '~/src/dash/components/dropdowns/common';
import { SimpleSingleSelect } from '~/src/dash/components/dropdowns/SimpleSingleSelect';
import { IconV2 } from '~/src/dash/components/icons/IconV2';
import { IInputRow, InputRow } from '~/src/dash/components/input-row';
import { spacing } from '~/src/dash/components/layout/common';
import {
  IBrandSafetyRuleAdomainExceptionRowData,
  IBrandSafetyRuleExceptionRowData,
  ICountryGroupRowData,
  IListTableColumn,
  ListTable,
} from '~/src/dash/components/list-table';
import {
  ILocalTargetingParameter,
  LocalTargeting,
  validateLocalTargetingRule,
} from '~/src/dash/components/local-targeting/local-targeting';
import { MaterialSearchDropdownMulti } from '~/src/dash/components/material-search-dropdown-multi';
import { ModalSelectTable } from '~/src/dash/components/modal-select-table';
import ElevationScroll from '~/src/dash/components/model-elevation-scroll';
import { ModernTextField } from '~/src/dash/components/modern-text-field';
import { PillSwitcherV2 } from '~/src/dash/components/tabs/PillSwitcherV2';
import { SimpleTabs } from '~/src/dash/components/tabs/SimpleTabs';
import { SimpleTabSections } from '~/src/dash/components/tabs/SimpleTabSections';
import { Text } from '~/src/dash/components/text';
import { genTimezoneList } from '~/src/dash/globals/timezone';
import {
  borderRadius,
  ButtonV2,
  Col,
  Cols,
  ct,
  Div,
  fontSizing,
  IndependentSelectV2,
  ISimpleOption,
  Panel,
  Panels,
  Row,
  Rows,
  TextButton,
  TextInput,
  TKey,
  TooltipWithTranslation,
} from '~/src/dash/publicaUI';
import { IStore } from '~/src/dash/reducers/store';
import { getColorTheme, getResellerTitle } from '~/src/dash/resellers/utils/importResellerConfig';
import {
  extractRouteParams,
  navigate,
  RouteBidderSettingsExisting,
  RouteBrandSafetyEdit,
  RouteBrandSafetyList,
} from '~/src/dash/router/routes';
import { IListItem, IMenuList } from '~/src/dash/types/menuList';
import {
  IBaseState,
  IHistoryProps,
  IReduxActionProps,
  ISessionStateProps,
  IUserStateProps,
  IWithStylesProps,
} from '~/src/dash/types/props';
import { getDomain } from '~/src/dash/utils/brand-safety-rules';
import { publicaColors } from '~/src/dash/utils/colors';
import {
  generateCountriesMenuList,
  generateCountryMenuListFromIsos,
  generateNewTargetingCountryGroupList,
  getAllCountries,
} from '~/src/dash/utils/countries';
import { decorate } from '~/src/dash/utils/decorator';
import { IEndpointBuilderChip } from '~/src/dash/utils/endpointBuilderService';
import {
  IABCategory,
  IABCategoryCodeToName,
  IABCategoryToTKey,
  IABSubcategoryToTKey,
} from '~/src/dash/utils/iab-category';
import {
  errorColor,
  growGrid,
  growGridLeft,
  growGridRight,
} from '~/src/dash/utils/material-dashboard-react';
import { filterSitesByActive } from '~/src/dash/utils/models';
import { noopVoid } from '~/src/dash/utils/noop';
import { exportLocalTargetingToJSON } from '~/src/dash/utils/params';
import {
  allowedEmptyIPermissionCheck,
  IPermissionCheck,
  IS_AUTHORIZED,
  notAllowedEmptyIPermissionCheck,
} from '~/src/dash/utils/permission_service';
import { checkUserInfoMasked, hasRoleSuperUser } from '~/src/dash/utils/roles';
import {
  hasErrors,
  IErrors,
  regionValidationSetting,
  validatorFactory,
} from '~/src/dash/utils/validator';
import {
  generateCCPAOptions,
  generateCOPPAOptions,
} from '~/src/dash/views/bidder-settings-form-view';
import { ActionPill } from '~/src/dash/views/brand-safety/Rule/ActionPill';
import { getRuleNavigationConfig } from '~/src/dash/views/brand-safety/Rule/config';
import {
  IABCategoryTable,
  IIABCategoryTableItems,
} from '~/src/dash/views/brand-safety/Rule/IABCategoryTable';
import { SelectMode } from '~/src/dash/views/campaign/common';
import { SnackbarView } from '~/src/dash/views/snackbar-view';
import { TopBar } from '~/src/dash/views/topbar/TopBar';
import { isLanguageOversized } from '~/src/locales/common';

interface IProps
  extends IWithStylesProps,
    IReduxActionProps,
    ISessionStateProps,
    IUserStateProps,
    IHistoryProps {
  rule: IBrandSafetyRule;
  error: string;
}

interface IState extends IBaseState, IBrandSafetyRule {
  // snackbar ??
  loading: boolean;
  updating: boolean;
  snackbarMessage: string;
  snackbarError: boolean;
  // rule type - see BrandSafetyRuleType enum form brand-safety-rules.ts
  ruleType: number;
  // IAB
  iabList: IIABCategoryTableItems[]; // list of IAB displayed in the table
  userEntryIABPrefix: string; // IAB prefix of user's current entry
  userEntryIABSuffix: string; // IAB suffix of user's current entry
  userEntryIABPrefixAllowed: string;
  userEntryIABSuffixAllowed: string;
  userEntryIABList: string; // user's entry of comma separated IAB codes
  // Adomain
  adomain: string[]; // adomain list - displayed in the table
  adomainUserEntry: string; // adomain single user entry
  // Mediafile
  mediafiles: string[];
  mediafileUserEntry: string; // mediafile single user entry
  // Creative ID
  creativeIDs: string[]; // creative ID list - displayed in the table
  creativeIDUserEntry: string; // creative ID single user entry
  // Languages
  languages: TKey[];
  languageOptions: ISelectOption[];
  // Event Trackers
  eventTrackers: string[];
  eventTrackerUserEntry: string;
  TargetedEventTracker: string;
  // permissions
  hasPublisherWriteRight: IPermissionCheck;
  hasChannelWriteRight: IPermissionCheck;
  hasBidderWriteRight: IPermissionCheck;
  hasWriteCurrentRuleRight: IPermissionCheck;
  writeAuthorization: IPermissionCheck;
  targetingCountriesList: IMenuList;
  targetingCountryGroupList: IMenuList;
  localTargetingAllowedParameters: ILocalTargetingParameter[];
  localTargetingDisallowedParameters: ILocalTargetingParameter[];
  publisherCountryGroups: ICountryGroup[];
  createEditRegionName: string;
  createEditRegionList: IMenuList;
  createEditRegionID: string;
  updatingCountryGroup: boolean;
  openRegionCreateEditDialog: boolean;
  openRegionSelectDialog: boolean;
  openRegionSelectTable: boolean;
  deviceTargetingCountrySelectMode: SelectMode;
  errors: IErrors;
  commonRegionGroups: ICountryGroup[] | undefined;
  // creative validations
  allowedCreativeValidations: ICreativeValidation[];
  loadingCreativeValidations: boolean;
  openRuleTargetedExceptionDialog: boolean;
  openRuleTargetedExceptionDialogIABCode: string;
  selectedRowIdx: number | undefined;
  openBidderSelectTable: boolean;
  headerBidders: IHeaderBidder[];
  activeTabIndex: number;
  bidderOptions: ISelectOption[];
  bidderGroupOptions: ISelectOption[];
  channelOptions: ISelectOption[];
  channelGroupOptions: ISelectOption[];
  selectedBidderIDs: number[];
  selectedBidderGroupIDs: number[];
  selectedChannelIDs: number[];
  selectedChannelGroupIDs: number[];
  loadingBidderOptions: boolean;
  loadingBidderGroupOptions: boolean;
  loadingChannelOptions: boolean;
  loadingChannelGroupOptions: boolean;
  reactKey: number;
  // dayparting
  DaypartingIntervals: IDaypartingInterval[];
  Dayparting: string;
  enableViewerTimezone: boolean;
  DaypartingIsAllowed: EAllowStatus;
  isDaypartingActive: boolean;
  // timezone
  Timezone: string;
  timezoneOptions: ISelectOption[];
}

interface IChip {
  key: string;
  label: string;
  selected: boolean;
}

const ALL_LANGUAGES: TKey[] = [
  'English',
  'Spanish',
  'French',
  'Portuguese',
  'German',
  'Italian',
  'Korean',
  'Japanese',
];

// enum for tab ()
const RuleTargetingTab = 1;
const RuleExceptionTab = 2;
const isRuleTargetingTab = (tab: number): boolean => {
  return tab === RuleTargetingTab;
};

// regex that tests if an IAB string is correct or not
// see https://regex101.com/r/Hivbch/1
const iabRegexp = /^IAB\d+(-\d+)?$/;

// old regex that checks if a string is an adomain
// see https://regex101.com/r/CIGTP2/1
// const adomainRegexp = /^([a-z0-9][a-z0-9-]{1,61}[a-z0-9]\.)+[a-z]{2,4}(\.[a-z]{2,4})?$/;

// regex that checks if a string is an adomain
// see https://regex101.com/r/BZ1iLL/2
const adomainRegexp =
  /^([a-z0-9]{1}[a-z0-9-]{1,61}[a-z0-9]{1}\.)+[a-z]{2,4}(\.[a-z]{2,4}){0,1}(|\/[a-z0-9-\/]{1,61})$/;

// regex that check if a string is a mediafile domain
// see https://regex101.com/r/kJbHWZ/1
const mediafileDomainRegexp =
  /^(https?:\/\/)?([a-z0-9]{0}[a-z0-9-]{0,61}[a-z0-9]{1}\.)+[a-z]{2,4}(\.[a-z]{2,4}){0,1}(\/.*){0,9}$/;

const AdomainExactMatchExamples: Record<string, string[]> = {
  ottera: ['ads.ottera.tv', 'https://ottera.tv, www.ottera.tv/'],
  evrideo: ['evrideo-ads.tv', 'https://evrideo-ads.tv, www.evrideo-ads.tv/'],
  orka: ['pacific.orka.biz', 'https://orka.biz, www.orka.biz/'],
  philo: ['ads.philo.com', 'https://philo.com, www.philo.com/'],
  publica: ['getpublica.com', 'https://getpublica.com, www.getpublica.com/'],
};

const AdomainContainsExamples: Record<string, string[]> = {
  ottera: ['ottera', 'https://ottera.tv, www.ottera.tv/'],
  evrideo: ['evrideo', 'https://evrideo-ads.tv, www.evrideo-ads.tv/'],
  orka: ['orka', 'https://orka.biz, www.orka.biz/'],
  philo: ['philo', 'https://philo.com, www.philo.com/'],
  publica: ['publica', 'https://getpublica.com, ttps://getpublica.fr, www.getpublica.com/'],
};

export const BrandSafetyRuleEdit = decorate(
  {
    redux: (state: IStore) => {
      return {
        user: state.user,
        session: state.session,
      };
    },
    styles: (theme: Theme) => ({
      paper: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing(6),
        paddingLeft: theme.spacing(6) + 'px !important',
        paddingBottom: theme.spacing(2),
        marginBottom: theme.spacing(4),
      },
      campaignNameContainer: {
        display: 'inline-block',
        marginLeft: '10px',
        width: 'calc(50% - 2em)',
      },
      section: {
        display: 'block',
        marginBottom: theme.spacing(3),
      },
      button: {
        margin: theme.spacing(1),
      },
      button2: {
        marginLeft: theme.spacing(6),
        border: 'none',
      },
      button3: {
        marginLeft: theme.spacing(4),
        border: 'none',
      },
      centeredSwitch: {
        display: 'inline-flex',
        alignItems: 'center',
        marginLeft: '10px',
        marginRight: '60px',
      },
      textCenteredSpan: {
        display: 'inline-flex',
        alignItems: 'center',
      },
      spanDescription: {
        display: 'inline-flex',
        alignItems: 'center',
      },
      spanActive: {
        display: 'inline-flex',
        alignItems: 'center',
        width: '55px',
        fontWeight: 'bold',
      },
      uploadButton: {
        display: 'flex',
        'text-align': 'center',
      },
      datePickerSection: {
        display: 'inline-flex',
        'justify-content': 'center',
        'align-items': 'center',
      },
      growGrid,
      growGridLeft,
      growGridRight,
      errorColor: {
        color: errorColor,
      },
      table: {
        display: 'inline-block',
        marginTop: '10px',
        marginBottom: '10px',
      },
      danger: {
        color: 'red',
      },
      success: {
        color: 'green',
      },
      chip: {
        '&.MuiChip-colorPrimary': {
          backgroundColor: getColorTheme('chipSelectActiveBackground') + ' !important',
        },
      },
      spanSubHeader: {
        display: 'inline-flex',
        alignItems: 'center',
        width: 88,
        fontSize: 15,
      },
      centeredSwitchNoLeftMargin: {
        display: 'inline-flex',
        alignItems: 'center',
        marginRight: '40px',
      },
    }),
    router: true,
  },
  class extends React.Component<IProps, IState> {
    constructor(props: IProps) {
      super(props);
      this.state = this.assignBrandSafetyRuleToState();
    }

    assignBrandSafetyRuleToState = (): IState => {
      return {
        // insert rule in state
        ...this.props.rule,
        loading: false,
        updating: false,
        snackbarMessage: '',
        snackbarError: false,
        // rule type - see BrandSafetyRuleType enum form brand-safety-rules.ts
        ruleType: RuleTypeIAB,
        // IAB
        iabList: [] as IIABCategoryTableItems[], // list of IAB displayed in the table
        userEntryIABPrefix: '', // IAB prefix of user's current entry
        userEntryIABSuffix: '', // IAB suffix of user's current entry
        userEntryIABList: '', // user's entry of comma separated IAB codes
        // Adomain
        adomain: [] as string[], // adomain list - displayed in the table
        adomainUserEntry: '', // adomain single user entry
        subtitle: [] as IEndpointBuilderChip[],
        // Mediafile
        mediafiles: [] as string[],
        mediafileUserEntry: '',
        // CreativeIDs
        creativeIDs: [] as string[],
        creativeIDUserEntry: '',
        // Languages
        languages: [] as TKey[],
        languageOptions: [] as ISelectOption[],
        // EventTrackers
        eventTrackers: [] as string[],
        eventTrackerUserEntry: '',
        TargetedEventTracker: '',
        // Arrays to store info for allowed IAB and Adomains in each exceptions
        channels: [] as ISite[],
        channelGroups: [] as IChannelGroup[],
        headerBidders: [] as IHeaderBidder[],
        bidderListAllowed: {} as IMenuList,
        iabListAllowed: [] as IIABCategoryTableItems[], // list of IAB displayed in the table - in exception panel
        userEntryIABPrefixAllowed: '', // IAB prefix of user's current entry - in exception panel
        userEntryIABSuffixAllowed: '', // IAB suffix of user's current entry - in exception panel
        userEntryIABListAllowed: '', // user's entry of comma separated IAB codes - in exception panel
        adomainAllowed: [] as string[], // adomain list - displayed in the table - in exception panel
        adomainUserEntryAllowed: '', // adomain single user entry - in exception panel
        // permissions
        hasPublisherWriteRight:
          notAllowedEmptyIPermissionCheck /* TODO uncomment to release global targeting - IS_AUTHORIZED(['write_publisher_brandsafety_rule'], this.props.user.user) */,
        hasChannelWriteRight: IS_AUTHORIZED(
          ['write_channel_brandsafety_rule'],
          this.props.user.user,
        ),
        hasBidderWriteRight: IS_AUTHORIZED(
          ['write_channel_brandsafety_rule'],
          this.props.user.user,
        ),
        hasWriteCurrentRuleRight: allowedEmptyIPermissionCheck,
        openEditRuleException: false,
        openBidderSelectTable: false,
        selectedRowIdx: undefined,
        writeAuthorization: IS_AUTHORIZED(['write_channel_brandsafety_rule'], this.props.user.user),
        localTargetingAllowedParameters: [] as ILocalTargetingParameter[],
        localTargetingDisallowedParameters: [] as ILocalTargetingParameter[],
        // createEditRegionList: {} as IMenuList,
        publisherCountryGroups: [] as ICountryGroup[],
        createEditRegionID: '',
        createEditRegionName: '',
        createEditRegionList: generateCountriesMenuList(),
        targetingCountryGroupList: {} as IMenuList,
        targetingCountriesList: generateCountriesMenuList(),
        updatingCountryGroup: false,
        openRegionCreateEditDialog: false,
        openRegionSelectDialog: false,
        openRegionSelectTable: false,
        deviceTargetingCountrySelectMode: SelectMode.Allowlist,
        errors: {} as IErrors,
        commonRegionGroups: [] as ICountryGroup[],
        // creative validations
        allowedCreativeValidations: [] as ICreativeValidation[],
        loadingCreativeValidations: false,
        openRuleTargetedExceptionDialog: false,
        openRuleTargetedExceptionDialogIABCode: '',
        activeTabIndex: 0, // active tab index for the rule targeting and exceptions tabs
        bidderOptions: [] as ISelectOption[],
        bidderGroupOptions: [] as ISelectOption[],
        channelOptions: [] as ISelectOption[],
        channelGroupOptions: [] as ISelectOption[],
        selectedBidderIDs: [],
        selectedBidderGroupIDs: [],
        selectedChannelIDs: [],
        selectedChannelGroupIDs: [],
        loadingBidderOptions: true,
        loadingBidderGroupOptions: true,
        loadingChannelOptions: true,
        loadingChannelGroupOptions: true,
        reactKey: 0,

        // dayparting
        Dayparting: this.props.rule.Dayparting || '',
        enableViewerTimezone: false,
        DaypartingIsAllowed: this.props.rule.DaypartingIsAllowed || EAllowStatus.ALLOW,
        DaypartingIntervals: [
          {
            ActiveDays: {
              Sunday: false,
              Monday: false,
              Tuesday: false,
              Wednesday: false,
              Thursday: false,
              Friday: false,
              Saturday: false,
            },
            StartTime: moment().startOf('day'),
            EndTime: moment().startOf('day').add(12, 'hours'),
            Error: '',
          },
        ],
        isDaypartingActive: false,

        // timezone
        Timezone: this.props.rule.Timezone || this.props.session.publisher.Timezone,
        timezoneOptions: [] as ISelectOption[],
      };
    };

    // initialization function
    componentDidMount(): void {
      // handle loading error
      if (this.props.error !== '') {
        // display error message to user
        this.setState({
          snackbarError: true,
          snackbarMessage: this.props.error,
        });
        // return to main page after 3 secs
        setTimeout(() => this.navigateToRuleListView(), 3000);
        // stop initialization here
        return;
      }
      // specific for existing rules
      if (this.state.ID !== 0) {
        // for existing rules → checks if the user has the write rights
        this.checkIfUserHasWriteRight();
        // for existing rules → rule type initialization
        this.initializeIABList();
        this.initializeAdomainList();
        this.initializeMediafileList();
        this.initializeCreativeIDList();
        this.initializeEventTrackerList();
      }
      this.initializeLanguageList();

      // rule targeting dropdown initializations
      this.initializeChannelList();
      this.initializeChannelGroupList();
      this.initializeBidderList();
      this.initializeBidderGroupList();

      // Geo
      void this.getCountryGroupsByPublisherID();
      this.populateTargetingCountriesList();
      this.importLocalTargetingParamFromJSON(true, this.state.LocalTargetingAllowed);
      this.importLocalTargetingParamFromJSON(false, this.state.LocalTargetingDisallowed);
      void this.getCommonRegionGroupsByIDs();

      void this.getCreativeValidationsAllowed();
      this.initializeMenuListFromTargetedIABs();

      // dayparting
      this.parseDayparting();
      this.getTimezoneList();
    }

    // gets if the current user had the write right on the current rule and save it in the state
    checkIfUserHasWriteRight(): void {
      let rights = allowedEmptyIPermissionCheck;
      switch (this.state.RuleTargetingType) {
        case BrandSafetyRuleTargetingTypeGlobal:
          rights = this.state.hasPublisherWriteRight;
          break;
        case BrandSafetyRuleTargetingTypeChannel:
        case BrandSafetyRuleTargetingTypeChannelGroup:
          rights = this.state.hasChannelWriteRight;
          break;
        case BrandSafetyRuleTargetingTypeBidder:
        case BrandSafetyRuleTargetingTypeBidderGroup:
          rights = this.state.hasBidderWriteRight;
          break;
        default:
          rights = notAllowedEmptyIPermissionCheck;
      }
      this.setState({
        hasWriteCurrentRuleRight: rights,
      });
    }

    // initialize the list of Adomain when loading an existing rule
    initializeAdomainList(): void {
      // checks if rule is Adomain type
      if (this.state.TargetedAdomains === '') {
        return; // rule is not an IAB rule
      }
      // rule in an Adomain rule
      // need to userEntryIABPrefixAllowed, userEntryIABSuffixAllowed, userEntryIABListAllowed, adomain
      this.setState({
        ruleType: RuleTypeAdomain,
        adomain: this.state.TargetedAdomains.split(','),
        iabListAllowed: this.state.BrandSafetyRuleExceptions.map((e: IBrandSafetyRuleException) =>
          this.getIABListAllowed(e.AllowedIABCategories),
        ),
      });
    }

    getIABListAllowed(input: string): IIABCategoryTableItems[] {
      return input.split(',').map((iabCode: string) => {
        const cleanIABCode = iabCode.replace('!', '');
        return {
          ID: cleanIABCode,
          title: cleanIABCode,
          name: this.IABCategoryCodeToNameWithTranslation(cleanIABCode),
          included: true,
        } as IIABCategoryTableItems;
      });
    }

    IABCategoryCodeToNameWithTranslation(name: string): string {
      const parts = name.split('-');
      if (parts.length > 2) {
        return '?'; // invalid IAB code
      } else if (parts.length === 1) {
        return ct(IABCategoryToTKey[parts[0] as IABCategory]);
      }

      const prefix = parts[0] as IABCategory;
      const suffix = Number(parts[1]);
      if (!IABSubcategoryToTKey?.[prefix]?.[suffix]) {
        return '?'; // invalid IAB code
      }

      // return the translation key for the IAB category and subcategory
      return `${ct(IABCategoryToTKey[prefix])}: ${ct(IABSubcategoryToTKey?.[prefix]?.[suffix])}`;
    }

    // initializes the list of IAB when loading an existing rule
    initializeIABList(): void {
      // checks if rule is IAB type
      if (this.state.TargetedIABs === '') {
        return; // rule is not an IAB rule
      }
      // rule is an IAB rule
      this.setState({
        ruleType: RuleTypeIAB,
        iabList: this.state.TargetedIABs.split(',').map((iabCode: string) => {
          const cleanIABCode = iabCode.replace('!', '');
          return {
            ID: cleanIABCode,
            title: cleanIABCode,
            name: this.IABCategoryCodeToNameWithTranslation(cleanIABCode),
            included: !iabCode.startsWith('!'),
          } as IIABCategoryTableItems;
        }),
        adomainAllowed: this.state.BrandSafetyRuleExceptions.map((e: IBrandSafetyRuleException) =>
          e.AllowedAdomains.split(','),
        ),
      });
    }

    getLanguagesAsIMenuList(selectedLanguages?: string[]): IMenuList {
      const out = {} as IMenuList;

      ALL_LANGUAGES.forEach((language) => {
        out[language] = {
          selected: selectedLanguages ? selectedLanguages.includes(language) : false,
          ID: language,
          title: ct(language),
        } as IListItem;
      });

      return out;
    }

    getLanguageOptions(): ISelectOption[] {
      return ALL_LANGUAGES.map((language) => ({
        id: language as string,
        label: ct(language),
      }));
    }

    initializeLanguageList(): void {
      // if an existing rule that is a Language rule
      if (this.state.ID !== 0 && this.state.TargetedLanguages !== '') {
        this.setState({
          ruleType: RuleTypeLanguage,
          languages: this.state.TargetedLanguages.split(',') as TKey[],
          languageOptions: this.getLanguageOptions(),
        });
      } else {
        // if its a new rule or not a language rule
        this.setState({
          languageOptions: this.getLanguageOptions(),
        });
      }
    }

    initializeMediafileList(): void {
      // checks if rule is Mediafile type
      if (this.state.TargetedMediafiles === '') {
        return; // rule is not a Mediafile rule
      }
      // rule in a Mediafile rule
      this.setState({
        ruleType: RuleTypeMediafile,
        mediafiles: this.state.TargetedMediafiles.split('\t'),
        iabListAllowed: this.state.BrandSafetyRuleExceptions.map((e: IBrandSafetyRuleException) =>
          this.getIABListAllowed(e.AllowedIABCategories),
        ),
        adomainAllowed: this.state.BrandSafetyRuleExceptions.map((e: IBrandSafetyRuleException) =>
          e.AllowedAdomains.split(','),
        ),
      });
    }

    initializeCreativeIDList(): void {
      // checks if rule is creativeID type
      if (this.state.TargetedCreativeIDs === '') {
        return; // rule is not a creativeID rule
      }
      // rule in a creativeID rule
      this.setState({
        ruleType: RuleTypeCreativeID,
        creativeIDs: this.state.TargetedCreativeIDs.split(','),
        iabListAllowed: this.state.BrandSafetyRuleExceptions.map((e: IBrandSafetyRuleException) =>
          this.getIABListAllowed(e.AllowedIABCategories),
        ),
        adomainAllowed: this.state.BrandSafetyRuleExceptions.map((e: IBrandSafetyRuleException) =>
          e.AllowedAdomains.split(','),
        ),
      });
    }

    initializeEventTrackerList(): void {
      // checks if rule is event tracker type
      if (this.state.TargetedEventTrackers === '') {
        return;
      }
      // rule is an event tracker rule
      this.setState({
        ruleType: RuleTypeEventTracker,
        eventTrackers: this.state.TargetedEventTrackers.split('\t'),
      });
    }

    initializeBidderGroupList(): void {
      // get bidder group list from API
      getBidderGroups({
        query: {
          publisher_id: this.props.session.publisher.ID,
        },
      }).then(({ bidderGroups }: { bidderGroups: IBidderGroup[] }) => {
        const bidderGroupOptions: ISelectOption[] = bidderGroups.map(
          (bidderGroup: IBidderGroup) => {
            const bidderGroupName = checkUserInfoMasked(this.props.user.user)
              ? 'BidderGroup_' + bidderGroup.ID // masked info
              : `${bidderGroup.Name}: (${bidderGroup.BidderIDs.split(',').length} Bidders)`; // real name
            return {
              id: Number(bidderGroup.ID),
              label: bidderGroupName,
            };
          },
        );

        this.setState({
          loadingBidderGroupOptions: false,
          bidderGroupOptions,
          selectedBidderGroupIDs:
            this.state.RuleTargetingType === BrandSafetyRuleTargetingTypeBidderGroup
              ? this.state.TargetedObjects.filter(
                  (t) => t.TargetingType === BrandSafetyRuleTargetingTypeBidderGroup,
                ).map((t) => t.TargetID)
              : [],
        });
      });
    }

    generateBidderListAllowed(): IMenuList {
      const { headerBidders, BrandSafetyRuleExceptions, selectedRowIdx } = this.state;
      const bidderListAllowed = {} as IMenuList;
      const exception =
        selectedRowIdx !== undefined
          ? BrandSafetyRuleExceptions[selectedRowIdx]
          : ({} as IBrandSafetyRuleException);
      headerBidders
        .filter((hb: IHeaderBidder): boolean => {
          const targetChannels = this.getTargetChannelIDs();
          return targetChannels.reduce(
            (ret: boolean, channelIDStr: string) =>
              ret || hb.SiteIDS.includes(parseInt(channelIDStr, 10)),
            false,
          );
        })
        .forEach((hb: IHeaderBidder) => {
          const bidderIDs =
            !isEmpty(exception) && exception.BidderIDs !== ''
              ? exception.BidderIDs.split(',')
              : ([] as string[]);
          const bidderName = checkUserInfoMasked(this.props.user.user)
            ? 'Bidder_' + hb.ID
            : hb.Name;
          bidderListAllowed[hb.ID] = {
            title: bidderName,
            selected: bidderIDs.includes(hb.ID),
            ID: hb.ID,
          };
        });
      return bidderListAllowed;
    }

    initializeBidderList(): void {
      // get bidder list from API
      queryHeaderBidders({
        query: {
          publisher_id: this.props.session.publisher.ID,
          site_ids: '',
          include_deleted: false,
        },
      }).then((headerBidders: IHeaderBidder[]) => {
        // filter and enrich the headerBidders
        const enrichedheaderBidders = this.enrichBidders(
          headerBidders.filter((hb: IHeaderBidder) => hb.Active === HeaderBidderActiveActive),
        );

        const bidderOptions: ISelectOption[] = headerBidders.map((bidder: IHeaderBidder) => {
          const bidderName = checkUserInfoMasked(this.props.user.user)
            ? 'Bidder_' + bidder.ID // masked info
            : bidder.Name;
          return {
            id: Number(bidder.ID),
            label: bidderName,
          };
        });

        this.setState({
          loadingBidderOptions: false,
          headerBidders: enrichedheaderBidders,
          bidderOptions,
          selectedBidderIDs:
            this.state.RuleTargetingType === BrandSafetyRuleTargetingTypeBidder
              ? this.state.TargetedObjects.filter(
                  (t) => t.TargetingType === BrandSafetyRuleTargetingTypeBidder,
                ).map((t) => t.TargetID)
              : [],
        });
      });
    }

    enrichBidders = (bidderList: IHeaderBidder[]): IHeaderBidder[] => {
      // For all bidder in list
      for (let i = 0; i < bidderList.length; i++) {
        // Enrich the bidder channel list /w all the channel included in the channel-group targeting
        // For all bidder channel-group targeting
        for (const channelGroup of bidderList[i].ChannelGroups) {
          // For all channel in channel-group
          for (const channelIDStr of channelGroup.ChannelIDs.split(',')) {
            // If this channel-group's channel is valid, then insert it in bidder's channel targeting
            const channelIdNbr = Number(channelIDStr);
            if (!isNaN(channelIdNbr) && channelIdNbr !== 0) {
              bidderList[i].SiteIDS.push(channelIdNbr);
            }
          }
        }

        // Dedup the bidder channel list and remove the channel that can't be found in state.activeSites
        const dedupMap = new Map();
        const newChannelList: number[] = [];
        for (const siteID of bidderList[i].SiteIDS) {
          // Check duplication
          if (!dedupMap.has(siteID)) {
            // Duplication ok, check if channel exists in state.activeSites
            dedupMap.set(siteID, true);
            newChannelList.push(siteID);
          }
        }
        bidderList[i].SiteIDS = newChannelList;
      }

      return bidderList;
    };

    // initialize for channel group selector
    initializeChannelGroupList(): void {
      // get channel groups from API
      getChannelGroupsPromise({
        publisherID: this.props.session.publisher.ID,
      }).then(({ channelGroups }: { channelGroups: IChannelGroup[] }) => {
        const channelGroupOptions: ISelectOption[] = channelGroups.map(
          (channelGroup: IChannelGroup) => {
            const channelGroupName = checkUserInfoMasked(this.props.user.user)
              ? 'ChannelGroup_' + channelGroup.ID // masked info
              : `${channelGroup.Name}: (${channelGroup.SitesInfo.length} Sites)`; // real name
            return {
              id: channelGroup.ID,
              label: channelGroupName,
            };
          },
        );

        this.setState({
          loadingChannelGroupOptions: false,
          channelGroups,
          channelGroupOptions,
          selectedChannelGroupIDs:
            this.state.RuleTargetingType === BrandSafetyRuleTargetingTypeChannelGroup
              ? this.state.TargetedObjects.filter(
                  (t) => t.TargetingType === BrandSafetyRuleTargetingTypeChannelGroup,
                ).map((t) => t.TargetID)
              : [],
        });
      });
    }

    // initialize for channel selector
    async initializeChannelList(): Promise<void> {
      // get active channels from session
      const [smallSites, err] = await getSmallSites(this.props.session.publisher.ID);
      if (err) {
        console.error(err);
        return;
      }

      const activeChannels = filterSitesByActive(smallSites || []);

      const channelOptions: ISelectOption[] = activeChannels.map((channel: ISmallSite) => {
        const channelName = checkUserInfoMasked(this.props.user.user)
          ? 'Channel_' + channel.ID // masked info
          : channel.Name;
        return {
          id: channel.ID,
          label: channelName,
        };
      });

      this.setState({
        loadingChannelOptions: false,
        channels: activeChannels,
        channelOptions,
        selectedChannelIDs:
          this.state.RuleTargetingType === BrandSafetyRuleTargetingTypeChannel
            ? this.state.TargetedObjects.filter(
                (t) => t.TargetingType === BrandSafetyRuleTargetingTypeChannel,
              ).map((t) => t.TargetID)
            : [],
      });
    }

    // [LocalTargeting] importLocalTargetingParamFromJSON imports JSON to local targeting params
    importLocalTargetingParamFromJSON = (allowed: boolean, inputJSON: string): void => {
      if (inputJSON === undefined || inputJSON.length === 0) {
        return;
      }
      let localParams: ILocalTargetingParameter[] = [];
      try {
        localParams = (JSON.parse(inputJSON) as object[]).map((o: ILocalTargetingParameter) => ({
          ...o,
          currentValue: '',
          isInputInCommaSeparatedMode: false,
        }));
      } catch (e) {
        // Ignore JSON parse errors
      }
      if (allowed) {
        this.setState({
          localTargetingAllowedParameters: localParams,
        });
      } else {
        this.setState({
          localTargetingDisallowedParameters: localParams,
        });
      }
    };

    saveRule(): void {
      const { isDaypartingActive, enableViewerTimezone, DaypartingIntervals, Timezone } =
        this.state;

      // transform state into IBrandSafetyRule object
      const selectedCountryGroupItems = Object.values(this.state.targetingCountryGroupList).filter(
        (item: IListItem) => item.selected,
      );

      const selectedCountries = Object.values(this.state.targetingCountriesList).filter(
        (item: IListItem) => item.selected,
      );

      // Create Dayparting Object
      // we always want to parse dayparting non-inverted for the DB
      const Dayparting = parseDaypartingIntervals(
        DaypartingIntervals,
        isDaypartingActive,
        Timezone,
        true,
        enableViewerTimezone,
      );

      const rule = {
        ID: this.state.ID,
        ResponseBlockedLastUpdated:
          this.state.ResponseBlockedLastUpdated === ''
            ? moment().format('YYYY-MM-DDTHH:mm:ssZ')
            : this.state.ResponseBlockedLastUpdated,
        PublisherID: this.state.PublisherID,
        Name: this.state.Name,
        Active: this.state.Active,
        RuleTargetingType: this.state.RuleTargetingType,
        NbrResponseBlocked: this.state.NbrResponseBlocked,
        IsTargetingExcluded:
          this.state.RuleTargetingType === BrandSafetyRuleTargetingTypeGlobal
            ? false
            : this.state.IsTargetingExcluded,
        IsTypeTargetingExcluded: this.state.IsTypeTargetingExcluded,
        BrandSafetyRuleExceptions: this.state.BrandSafetyRuleExceptions.filter(
          (exception: IBrandSafetyRuleException) => {
            if (
              exception.AllowedAdomainsState ===
              BrandSafetyRuleTargetingAdomainExceptionStateAllowAll
            )
              return true;
            return !(exception.AllowedAdomains === '' && exception.AllowedIABCategories === '');
          },
        ),
        TargetedObjects: this.createTargetedObjectsTable(),
        EnableSaveCreativeValidations: this.state.EnableSaveCreativeValidations,
        EnableBlockBidsWithEmptyIABCatAdomain: this.state.EnableBlockBidsWithEmptyIABCatAdomain,
        // Targeted Content
        TargetedContentCategory: this.state.TargetedContentCategory,
        TargetedContentCategoryIsAllowed: this.state.TargetedContentCategoryIsAllowed,
        TargetedContentChannel: this.state.TargetedContentChannel,
        TargetedContentChannelIsAllowed: this.state.TargetedContentChannelIsAllowed,
        TargetedContentDistributor: this.state.TargetedContentDistributor,
        TargetedContentDistributorIsAllowed: this.state.TargetedContentDistributorIsAllowed,
        TargetedContentGenre: this.state.TargetedContentGenre,
        TargetedContentGenreIsAllowed: this.state.TargetedContentGenreIsAllowed,
        TargetedContentID: this.state.TargetedContentID,
        TargetedContentIDIsAllowed: this.state.TargetedContentIDIsAllowed,
        TargetedContentNetwork: this.state.TargetedContentNetwork,
        TargetedContentNetworkIsAllowed: this.state.TargetedContentNetworkIsAllowed,
        TargetedContentProducer: this.state.TargetedContentProducer,
        TargetedContentProducerIsAllowed: this.state.TargetedContentProducerIsAllowed,
        TargetedContentRating: this.state.TargetedContentRating,
        TargetedContentRatingIsAllowed: this.state.TargetedContentRatingIsAllowed,
        TargetedContentSeries: this.state.TargetedContentSeries,
        TargetedContentSeriesIsAllowed: this.state.TargetedContentSeriesIsAllowed,
        TargetedContentTitle: this.state.TargetedContentTitle,
        TargetedContentTitleIsAllowed: this.state.TargetedContentTitleIsAllowed,

        // targeting app/site
        TargetedAppBundleID: this.state.TargetedAppBundleID,
        TargetedAppBundleIDIsAllowed: this.state.TargetedAppBundleIDIsAllowed,
        TargetedSitePages: this.state.TargetedSitePages,
        TargetedSitePagesIsAllowed: this.state.TargetedSitePagesIsAllowed,

        // Targeted other
        TargetedVenueID: this.state.TargetedVenueID,
        TargetedVenueIDIsAllowed: this.state.TargetedVenueIDIsAllowed,
        TargetedCoppa: this.state.TargetedCoppa,

        // Targeted Custom
        TargetedCustom4: this.state.TargetedCustom4,
        TargetedCustom4IsAllowed: this.state.TargetedCustom4IsAllowed,
        TargetedCustom5: this.state.TargetedCustom5,
        TargetedCustom5IsAllowed: this.state.TargetedCustom5IsAllowed,
        TargetedCustom6: this.state.TargetedCustom6,
        TargetedCustom6IsAllowed: this.state.TargetedCustom6IsAllowed,
        TargetedCustom7: this.state.TargetedCustom7,
        TargetedCustom7IsAllowed: this.state.TargetedCustom7IsAllowed,
        TargetedCustom8: this.state.TargetedCustom8,
        TargetedCustom8IsAllowed: this.state.TargetedCustom8IsAllowed,
        TargetedCustom9: this.state.TargetedCustom9,
        TargetedCustom9IsAllowed: this.state.TargetedCustom9IsAllowed,
        TargetedCustom10: this.state.TargetedCustom10,
        TargetedCustom10IsAllowed: this.state.TargetedCustom10IsAllowed,
        TargetedCustom11: this.state.TargetedCustom11,
        TargetedCustom11IsAllowed: this.state.TargetedCustom11IsAllowed,
        TargetedCustom12: this.state.TargetedCustom12,
        TargetedCustom12IsAllowed: this.state.TargetedCustom12IsAllowed,
        TargetedCustom13: this.state.TargetedCustom13,
        TargetedCustom13IsAllowed: this.state.TargetedCustom13IsAllowed,
        TargetedCustom14: this.state.TargetedCustom14,
        TargetedCustom14IsAllowed: this.state.TargetedCustom14IsAllowed,
        TargetedCustom15: this.state.TargetedCustom15,
        TargetedCustom15IsAllowed: this.state.TargetedCustom15IsAllowed,
        TargetedCustom16: this.state.TargetedCustom16,
        TargetedCustom16IsAllowed: this.state.TargetedCustom16IsAllowed,
        TargetedCustom17: this.state.TargetedCustom17,
        TargetedCustom17IsAllowed: this.state.TargetedCustom17IsAllowed,
        TargetedCustom18: this.state.TargetedCustom18,
        TargetedCustom18IsAllowed: this.state.TargetedCustom18IsAllowed,
        TargetingAdomainExceptionState: this.state.TargetingAdomainExceptionState,

        //  Add Targeted Geo
        TargetingCountryGroupIDs: selectedCountryGroupItems
          .map((item: IListItem) => item.ID)
          .join(','),
        TargetingCountryGroupIDsIsAllowed: this.state.TargetingCountryGroupIDsIsAllowed,
        TargetingDeviceCountry: selectedCountries
          .map((item: IListItem) => item.ID.toUpperCase())
          .join(','),
        TargetingDeviceCountryIsAllowed: this.state.TargetingDeviceCountryIsAllowed,
        LocalTargetingAllowed: this.exportLocalTargetingParamToJSON(true),
        LocalTargetingDisallowed: this.exportLocalTargetingParamToJSON(false),
        CountryGroups: this.state.publisherCountryGroups,
        TargetingCCPA: this.state.TargetingCCPA,
        Dayparting,
        DaypartingIsAllowed: this.state.DaypartingIsAllowed,
        Timezone: this.state.Timezone,
      } as IBrandSafetyRule;

      // remove CreatedAt timestamp if it's brand new block rule
      if (rule.ID !== 0) {
        rule.CreatedAt = this.state.CreatedAt;
      }
      // save selected rule type (IAB, Adomain) object comma separated list
      if (this.state.ruleType === RuleTypeIAB) {
        rule.TargetedIABs = this.makeIABString();
        // if block_rule_type is IAB, overwrite the allowed_iab_categories list to empty
        rule.BrandSafetyRuleExceptions.forEach((_, idx: number) => {
          rule.BrandSafetyRuleExceptions[idx].AllowedIABCategories = '';
        });
      } else if (this.state.ruleType === RuleTypeAdomain) {
        rule.TargetedAdomains = this.makeAdomainString();
        // if block_rule_type is adomain, overwrite the allowed_adomains list to empty
        rule.BrandSafetyRuleExceptions.forEach((_, idx: number) => {
          rule.BrandSafetyRuleExceptions[idx].AllowedAdomains = '';
        });
        rule.TargetingAdomainExceptionState = this.state.TargetingAdomainExceptionState;
      } else if (this.state.ruleType === RuleTypeMediafile) {
        rule.TargetedMediafiles = this.makeMediafileDomainString();
      } else if (this.state.ruleType === RuleTypeCreativeID) {
        rule.TargetedCreativeIDs = this.makeCreativeIDString();
      } else if (this.state.ruleType === RuleTypeLanguage) {
        rule.TargetedLanguages = this.state.languages.join(',');
      } else if (this.state.ruleType === RuleTypeEventTracker) {
        rule.TargetedEventTrackers = this.state.eventTrackers.join('\t');
      }

      // validate rule
      const errorMessages: string[] = [
        ...validateLocalTargetingRule(
          this.state.localTargetingAllowedParameters,
          this.state.localTargetingDisallowedParameters,
        ),
      ];
      const ruleValidationErrorMessage = this.validateRule(
        rule,
        this.state.BrandSafetyRuleExceptions,
      );
      if (ruleValidationErrorMessage) {
        errorMessages.push(ruleValidationErrorMessage);
      }
      const errorMessage: string = errorMessages.join('; ');

      if (errorMessage) {
        this.setState({
          snackbarError: true,
          snackbarMessage: errorMessage,
        });
        return; // rule validation failed → stop here
      }

      // build request URL
      const reqURL =
        this.state.ID === 0
          ? createUrl('/brandsafetyrules', this.props.session.publisher.ID)
          : createUrl(`/brandsafetyrules/${this.state.ID}`, this.props.session.publisher.ID);
      // get the create or update request type
      const requestType = this.state.ID === 0 ? restPost : restPatch;
      const actionName = this.state.ID === 0 ? 'created' : 'updated';
      // make the request
      requestType<IBrandSafetyRule>(reqURL, rule)
        .then((val: IHttpResponse<IBrandSafetyRule>) => {
          const rule = val.parsedBody as IBrandSafetyRule;
          // OK
          this.setState(
            {
              snackbarError: false,
              snackbarMessage: ct('SnackbarSuccessfullyCreatedItem', { item: ct('Rule') }),
              // if not defined (when creating), update the ID of the rule locally with the one from API
              ID: this.state.ID === 0 ? rule.ID : this.state.ID,
            },
            () => {
              if (actionName === 'created' && rule.ID) {
                setTimeout(() => {
                  navigate(
                    RouteBrandSafetyEdit,
                    extractRouteParams({
                      session: this.props.session,
                      user: this.props.user,
                    }),
                    { brandSafetyRuleID: rule.ID.toString() },
                  );
                }, 1000);
              }
            },
          );
        })
        .catch(() => {
          // error
          this.setState({
            snackbarError: true,
            snackbarMessage: ct('SnackbarFailedToCreateItem', { item: ct('Rule') }),
          });
        });
    }

    // validate a rule before saving it
    validateRule(
      rule: IBrandSafetyRule,
      originalExceptions: IBrandSafetyRuleException[],
    ): string | undefined {
      // if rule is not global, rule must target at least 1 channel/bidder (or group)
      if (
        rule.RuleTargetingType !== BrandSafetyRuleTargetingTypeGlobal &&
        rule.TargetedObjects.length === 0
      ) {
        return ct('BrandSafetySnackbarRuleMustTargetAtLeastOneItem', {
          item: ct(BrandSafetyTargetingTypeToTKey[rule.RuleTargetingType]),
        });
      }

      // rule must target at least 1 IAB or adomain or mediafile domain or language or creativeID or event tracker
      if (
        !rule.TargetedIABs &&
        !rule.TargetedAdomains &&
        !rule.TargetedMediafiles &&
        !rule.TargetedLanguages &&
        !rule.TargetedCreativeIDs &&
        !rule.TargetedEventTrackers
      ) {
        return ct('BrandSafetySnackbarRuleMustTargetAtLeastOne');
      }

      // every brand safety rule exception must target at least one headerbidder
      const invalidExceptionNames = [] as string[];
      if (originalExceptions.length > 0) {
        originalExceptions.forEach((exception) => {
          if (exception.BidderIDs === '') {
            invalidExceptionNames.push(`${exception.Name}`);
          }
        });
        if (invalidExceptionNames.length > 1) {
          return ct('BrandSafetySnackbarRuleEachExceptionMustTargetAtLeastOneBidder');
        }
      }

      return undefined; // rule is valid
    }

    createTargetedObjectsTable(): IBrandSafetyRuleAssociationTable[] {
      // get the targeted entry list
      let selectedIDs = [] as number[];
      switch (this.state.RuleTargetingType) {
        case BrandSafetyRuleTargetingTypeBidder:
          selectedIDs = this.state.selectedBidderIDs;
          break;
        case BrandSafetyRuleTargetingTypeBidderGroup:
          selectedIDs = this.state.selectedBidderGroupIDs;
          break;
        case BrandSafetyRuleTargetingTypeChannel:
          selectedIDs = this.state.selectedChannelIDs;
          break;
        case BrandSafetyRuleTargetingTypeChannelGroup:
          selectedIDs = this.state.selectedChannelGroupIDs;
          break;
        default:
          return []; // global or unknown → no association possible
      }

      // create list
      return selectedIDs.map((id: number) => {
        return {
          TargetingType: this.state.RuleTargetingType, // association table have same target type as the rule
          TargetID: Number(id), // targeted object (bidder, channel) ID
        } as IBrandSafetyRuleAssociationTable;
      });
    }

    // transforms the IAB selection into a comma-separated string
    // this function will also convert the list of included/excluded IAB codes to a list of included IAB codes
    // ex: "IAB1-1,IAB2-1"
    makeIABString(): string {
      return this.state.iabList
        .map((list: IIABCategoryTableItems) => {
          if (list.included) {
            return list.ID;
          }
          return '!' + list.ID;
        })
        .join(',');
    }

    // transforms the Adomain selection into a comma-separated string
    // ex: "google.com,facebook.com"
    makeAdomainString(): string {
      return this.state.adomain.join(',');
    }

    // transforms the Mediafile domain selection into a tab-separated string
    // ex: "google.com  facebook.com" or "google.com\tfacebook.com"
    makeMediafileDomainString(): string {
      return this.state.mediafiles.join('\t');
    }

    // transforms the creative ids selection into a comma-separated string
    // ex: "google.com,facebook.com,twitter.com"
    makeCreativeIDString(): string {
      return this.state.creativeIDs.join(',');
    }

    handleChangeRuleTypeIABEntry(
      tab: number,
      newList: IIABCategoryTableItems[],
      title: string,
      idx?: number,
      disabled?: boolean,
    ): void {
      if (disabled) {
        return;
      }
      if (isRuleTargetingTab(tab)) {
        // clonedBrandSafetyRuleExceptions refers to all of the items in the Exceptions Allow List
        const clonedBrandSafetyRuleExceptions = cloneDeep(this.state.BrandSafetyRuleExceptions);
        for (let idx = 0; idx < clonedBrandSafetyRuleExceptions.length; idx++) {
          const brandSafetyRuleException = clonedBrandSafetyRuleExceptions[idx];
          const splitTargetedIABExceptions =
            brandSafetyRuleException.TargetedIABExceptions.split(',');
          const filteredTargetedIABExceptions = splitTargetedIABExceptions.filter(
            (targetedIABException) => targetedIABException !== title,
          );
          brandSafetyRuleException.TargetedIABExceptions = filteredTargetedIABExceptions.join(',');
        }

        const newTargetedIABs = this.state.TargetedIABs.split(',')
          .filter((targetedIAB) => targetedIAB !== '' && targetedIAB !== title)
          .join(',');

        this.setState({
          BrandSafetyRuleExceptions: clonedBrandSafetyRuleExceptions,
          TargetedIABs: newTargetedIABs,
          iabList: newList,
        });
      } else {
        const BrandSafetyRuleExceptions = cloneDeep(this.state.BrandSafetyRuleExceptions);
        if (idx !== undefined && !!BrandSafetyRuleExceptions[idx]) {
          BrandSafetyRuleExceptions[idx].AllowedIABCategories = newList
            .map((list: IIABCategoryTableItems) => list.title)
            .join(',');
          this.setState({
            BrandSafetyRuleExceptions,
            iabListAllowed: newList,
          });
        }
      }
    }

    // returns true if the user is creating a new rule, false if it edit an existing one
    isNewRule(): boolean {
      return this.state.ID === 0;
    }

    // close the notification snackbar
    snackbarClose = (): void => {
      this.setState({
        snackbarMessage: '',
        snackbarError: false,
      });
    };

    // handles the user click on the close button
    handleCloseButtonClick = (): void => {
      // if user is coming from the channel edit view (because of the channel's rule list), send it back to it
      if (this.props.session.brandSafetyReferrer === 'channel-edit') {
        window.history.back(); // return to the previous page
        return;
      }
      // else navigate to the brand safety rule list view
      this.navigateToRuleListView();
    };

    // navigate to the page listing all the rules
    navigateToRuleListView(): void {
      navigate(
        RouteBrandSafetyList,
        extractRouteParams({
          session: this.props.session,
          user: this.props.user,
        }),
      );
    }

    // handles click on rule targeting type chip (Global, Channel, Bidders ...)
    targetingTypeChangeHandler(newTargetedType: number): void {
      this.setState({
        RuleTargetingType: newTargetedType,
      });
    }

    // handles click on rule type chip (IAB, Adomain)
    typeChangeHandler(newRuleType: number): void {
      this.setState({
        ruleType: newRuleType,
      });
    }

    handleIABUserStringChange(input: string, tab: number): void {
      const value = input.split('-');
      if (value.length > 1 && value[1] === '') {
        value[1] = '-';
      }
      this.setState({
        [isRuleTargetingTab(tab) ? 'userEntryIABPrefix' : 'userEntryIABPrefixAllowed']:
          value[0].toUpperCase(),
        [isRuleTargetingTab(tab) ? 'userEntryIABSuffix' : 'userEntryIABSuffixAllowed']:
          (value.length > 1 ? value[1] : '').toUpperCase(),
      });
    }

    handleChangeList = (stateName: string) => {
      return (updatedMenuList: IMenuList) => {
        this.setState({
          [stateName]: updatedMenuList,
        });
      };
    };

    handleTypeTargetingExclusionChipClick(chip: IChip): void {
      if (!chip.selected) {
        if (chip.key === 'block') {
          this.setState({
            IsTypeTargetingExcluded: true,
          });
        } else if (chip.key === 'allow') {
          this.setState({
            IsTypeTargetingExcluded: false,
          });
        }
      }
    }

    // adds the Adomain user entry into the Adomain table
    addAdomainUserEntry(tab: number, idx?: number): void {
      const adomain = [
        ...(isRuleTargetingTab(tab) ? this.state.adomain : (this.state.adomainAllowed as string[])),
      ];
      const adomainUserEntry = (
        isRuleTargetingTab(tab)
          ? this.state.adomainUserEntry
          : (this.state.adomainUserEntryAllowed as string)
      ).toLowerCase();

      // check entry validity
      if (adomainUserEntry === '' || adomain.includes(adomainUserEntry)) {
        // user entry already exists in the list → error
        this.setState({
          snackbarError: true,
          snackbarMessage:
            adomainUserEntry === ''
              ? ct('ErrorItemCannotBeEmpty', { item: ct('Adomain') })
              : ct('SnackbarItemAlreadyExistWithReasons', {
                  item: ct('Adomain'),
                  text: adomainUserEntry,
                }),
          [isRuleTargetingTab(tab) ? 'adomainUserEntry' : 'adomainUserEntryAllowed']: '',
          reactKey: this.state.reactKey + 1, // force re-render
        });
        return;
      }

      // add user entry to table data array
      adomain.push(adomainUserEntry);
      // update state
      if (isRuleTargetingTab(tab)) {
        this.setState({
          adomain,
          adomainUserEntry: '',
          reactKey: this.state.reactKey + 1, // force re-render
        });
      } else {
        const BrandSafetyRuleExceptions = cloneDeep(this.state.BrandSafetyRuleExceptions);
        if (idx !== undefined && !!BrandSafetyRuleExceptions[idx]) {
          BrandSafetyRuleExceptions[idx].AllowedAdomains = adomain.join(',');
          this.setState({
            adomainAllowed: adomain,
            adomainUserEntryAllowed: '',
            BrandSafetyRuleExceptions,
            reactKey: this.state.reactKey + 1, // force re-render
          });
        }
      }
    }

    digestAdomainCSVFile(ev: ProgressEvent<FileReader>, tab: number, idx?: number): void {
      // initiate the adomainList that user is going to update depending on which tab user is on and the idx of rule_exception
      const adomainList = [
        ...(isRuleTargetingTab(tab) ? this.state.adomain : (this.state.adomainAllowed as string[])),
      ];

      // check target value
      if (ev.target === null) {
        return;
      }
      const content = ev.target.result as string;
      content.split('\n').forEach((line: string) => {
        // for each line
        line.split(',').forEach((entry: string) => {
          // for each CSV entry
          entry = entry.toLowerCase();
          entry = entry.replace('\r', '');
          // trim quotes (if any)
          if (entry.length >= 1 && (entry[0] === "'" || entry[0] === '"')) {
            entry = entry.substr(0, 1);
          }
          if (
            entry.length >= 1 &&
            (entry[entry.length - 1] === "'" || entry[entry.length - 1] === '"')
          ) {
            entry = entry.substr(entry.length - 1, 1);
          }
          // remove http:// and https:// and ending /
          entry = entry.replace(/(^\w+:|^)\/\//, '').replace(/\/$/, '');
          // check if it's a valid adomain
          if (adomainRegexp.test(entry) && !adomainList.includes(entry)) {
            // valid domain, add it
            adomainList.push(entry);
          }
        });
      });
      // refresh state
      if (isRuleTargetingTab(tab)) {
        this.setState({
          adomain: adomainList,
        });
      } else {
        const BrandSafetyRuleExceptions = cloneDeep(this.state.BrandSafetyRuleExceptions);
        if (idx !== undefined && !!BrandSafetyRuleExceptions[idx]) {
          BrandSafetyRuleExceptions[idx].AllowedAdomains = adomainList.join(',');
          this.setState({
            adomainAllowed: adomainList,
            BrandSafetyRuleExceptions,
          });
        }
      }
    }

    // handles user's selected adomain CSV file
    handleAdomainCSVFile(target: EventTarget & HTMLInputElement, tab: number, idx?: number): void {
      // check input
      if (!target.files || target.files.length === 0) {
        return; // no files selected → do nothing
      }
      const file = target.files[0];
      // read file

      const fr = new FileReader();
      fr.onload = (ev: ProgressEvent<FileReader>) => this.digestAdomainCSVFile(ev, tab, idx);
      fr.readAsText(file);
    }

    // adds the IAB user entry into the include/exclude table
    addIABUserEntry(tab: number, idx?: number): void {
      const userSingleIABString = this.getUserSingleIABString(tab);
      const iabList = [
        ...(isRuleTargetingTab(tab)
          ? this.state.iabList
          : (this.state.iabListAllowed as IIABCategoryTableItems[])),
      ];
      if (
        iabList.findIndex((elem: IIABCategoryTableItems) => elem.ID === userSingleIABString) !== -1
      ) {
        // user single entry already exists in the table → error
        this.setState({
          snackbarError: true,
          snackbarMessage: ct('SnackbarItemAlreadyExistWithReasons', {
            item: ct('IABCategory'),
            text: userSingleIABString,
          }),
          [isRuleTargetingTab(tab) ? 'userEntryIABPrefix' : 'userEntryIABPrefixAllowed']: '',
          [isRuleTargetingTab(tab) ? 'userEntryIABSuffix' : 'userEntryIABSuffixAllowed']: '',
        });
        return;
      }

      // insert user single entry
      let iabs: string[] = [userSingleIABString];
      // get user comma separated IAB list
      iabs = iabs.concat(
        (isRuleTargetingTab(tab)
          ? this.state.userEntryIABList
          : (this.state.userEntryIABListAllowed as string)
        )
          .toUpperCase()
          .split(',')
          .map((s: string) => s.trim()),
      );

      // remove bad strings from array
      iabs = iabs.filter((s: string) => iabRegexp.test(s));
      iabs.forEach((iab: string) => {
        if (iabList.findIndex((elem: IIABCategoryTableItems) => elem.ID === iab) === -1) {
          // if iab don't exist if, add it
          iabList.push({
            ID: iab,
            included: true,
            name: this.IABCategoryCodeToNameWithTranslation(iab),
            title: iab,
          });
        }
      });
      // refresh the state and reset input fields
      if (isRuleTargetingTab(tab)) {
        this.setState({
          iabList,
          userEntryIABPrefix: '',
          userEntryIABSuffix: '',
          userEntryIABList: '',
          TargetedIABs: iabList
            .map((iabListItem: IIABCategoryTableItems) => iabListItem.title)
            .join(','),
          reactKey: this.state.reactKey + 1, // force re-render
        });
      } else {
        const BrandSafetyRuleExceptions = cloneDeep(this.state.BrandSafetyRuleExceptions);
        if (idx !== undefined && !!BrandSafetyRuleExceptions[idx]) {
          BrandSafetyRuleExceptions[idx].AllowedIABCategories = iabList
            .map((list: IIABCategoryTableItems) => list.title)
            .join(',');
          this.setState({
            BrandSafetyRuleExceptions,
            iabListAllowed: iabList,
            userEntryIABPrefixAllowed: 'IAB',
            userEntryIABSuffixAllowed: '',
            userEntryIABListAllowed: '',
            reactKey: this.state.reactKey + 1, // force re-render
          });
        }
      }
    }

    // gets the single IAB string entered by the user (via the IAB prefix and IAB suffix dropdowns)
    // ex: 'IAB1-2' or 'IAB1'
    getUserSingleIABString(tab: number): string {
      const userEntryIABPrefix = isRuleTargetingTab(tab)
        ? this.state.userEntryIABPrefix
        : this.state.userEntryIABPrefixAllowed;
      const userEntryIABSuffix = isRuleTargetingTab(tab)
        ? this.state.userEntryIABSuffix
        : this.state.userEntryIABSuffixAllowed;
      return (
        userEntryIABPrefix +
        (userEntryIABSuffix !== ''
          ? (userEntryIABSuffix !== '-' ? '-' : '') + userEntryIABSuffix
          : '')
      );
    }

    // handles click on the delete button in the adomain list table
    handleAdomainDelete(index: number, tab: number, idx?: number): void {
      // remove element in list
      if (isRuleTargetingTab(tab)) {
        this.setState({
          adomain: update(this.state.adomain, { $splice: [[index, 1]] }) as string[],
        });
      } else {
        const adomainAllowed = cloneDeep(this.state.adomainAllowed) as string[];
        const BrandSafetyRuleExceptions = cloneDeep(this.state.BrandSafetyRuleExceptions);
        if (idx !== undefined && !!BrandSafetyRuleExceptions[idx]) {
          adomainAllowed.splice(index, 1);
          BrandSafetyRuleExceptions[idx].AllowedAdomains = adomainAllowed.join(',');
          this.setState({
            adomainAllowed,
            BrandSafetyRuleExceptions,
          });
        }
      }
    }

    // ############################## RENDER RULE TYPE ADOMAIN TABLE ##############################
    renderAdomainTable(tab: number, idx?: number): ReactElement {
      const adomains = [
        ...(isRuleTargetingTab(tab) ? this.state.adomain : (this.state.adomainAllowed as string[])),
      ];
      return (
        <TableContainer
          component={Paper}
          style={{
            width: '420px',
            boxShadow: 'none',
            borderRadius: borderRadius.base,
            border: `1px solid ${publicaColors.lightGray}`,
            borderBottom: 'none',
          }}
        >
          <Table size='small'>
            <TableHead style={{ backgroundColor: publicaColors.veryLightGray }}>
              <TableRow>
                <TableCell>
                  <Text tKey='Adomain' small bold />
                </TableCell>
                <TableCell align='center'>
                  <Text tKey='Delete' small bold />
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {isEmpty(adomains) ? (
                <TableRow>
                  <TableCell>
                    <Text tKey='None' />
                  </TableCell>
                  <TableCell />
                </TableRow>
              ) : (
                adomains.map((adomain: string, index: number) => (
                  <TableRow>
                    <TableCell>
                      <Text>{adomain}</Text>
                    </TableCell>
                    <TableCell align='center'>
                      <ButtonV2
                        clearBackground
                        onClick={() => this.handleAdomainDelete(index, tab, idx)}
                      >
                        <Div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <IconV2 name='delete' large color={publicaColors.gray} />
                        </Div>
                      </ButtonV2>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      );
    }

    renderAdomainExceptionTable(): ReactElement {
      const { BrandSafetyRuleExceptions, openRuleTargetedExceptionDialogIABCode } = this.state;
      const renderAdomainSet = new Set<string>();
      for (const brandSafetyRuleException of BrandSafetyRuleExceptions) {
        const splitTargetedIABExceptions =
          brandSafetyRuleException.TargetedIABExceptions.split(',');
        const foundTargetedIABException =
          splitTargetedIABExceptions.find(
            (targetedIABException) =>
              targetedIABException === openRuleTargetedExceptionDialogIABCode,
          ) !== undefined;
        if (foundTargetedIABException) {
          const splitAllowedAdomains = brandSafetyRuleException.AllowedAdomains.split(',');
          for (const allowedAdomain of splitAllowedAdomains) {
            renderAdomainSet.add(allowedAdomain);
          }
        }
      }

      const renderAdomainArr = Array.from(renderAdomainSet);
      renderAdomainArr.sort();

      const listTableColumns: IListTableColumn[] = [
        { field: 'Adomain', title: ct('Adomain'), renderType: 'normal', searchable: true },
      ];

      const exceptionData = renderAdomainArr.map(
        (allowedAdomain: string, idx: number): IBrandSafetyRuleAdomainExceptionRowData => {
          return {
            Adomain: allowedAdomain,
            ID: idx,
            Name: allowedAdomain,
          };
        },
      );

      return (
        <ListTable
          title={ct('Exceptions')}
          columns={listTableColumns}
          data={exceptionData}
          handleSetUpdating={noopVoid}
        />
      );
    }

    // ############################## RENDER RULE TYPE ADOMAIN ENTRY COMPONENT ##############################
    renderRuleTypeAdomainEntry(
      tab: number,
      renderAllowAllOption: boolean,
      disabled: boolean,
      allowedAdomainsState: BrandSafetyRuleTargetingAdomainExceptionState,
      idx?: number,
    ): ReactElement {
      const getHelperTextTProps = (exactMatch: boolean): Record<string, string> => {
        if (exactMatch) {
          switch (getResellerTitle()) {
            case 'OTTera':
              return {
                text: AdomainExactMatchExamples.ottera[0],
                altText: AdomainExactMatchExamples.ottera[1],
              };
            case 'Evrideo':
              return {
                text: AdomainExactMatchExamples.evrideo[0],
                altText: AdomainExactMatchExamples.evrideo[1],
              };
            case 'Orka':
              return {
                text: AdomainExactMatchExamples.orka[0],
                altText: AdomainExactMatchExamples.orka[1],
              };
            case 'Philo':
              return {
                text: AdomainExactMatchExamples.philo[0],
                altText: AdomainExactMatchExamples.philo[1],
              };
            default:
              return {
                text: AdomainExactMatchExamples.publica[0],
                altText: AdomainExactMatchExamples.publica[1],
              };
          }
        }

        switch (getResellerTitle()) {
          case 'OTTera':
            return {
              text: AdomainContainsExamples.ottera[0],
              altText: AdomainContainsExamples.ottera[1],
            };
          case 'Evrideo':
            return {
              text: AdomainContainsExamples.evrideo[0],
              altText: AdomainContainsExamples.evrideo[1],
            };
          case 'Orka':
            return {
              text: AdomainContainsExamples.orka[0],
              altText: AdomainContainsExamples.orka[1],
            };
          case 'Philo':
            return {
              text: AdomainContainsExamples.philo[0],
              altText: AdomainContainsExamples.philo[1],
            };
          default:
            return {
              text: AdomainContainsExamples.publica[0],
              altText: AdomainContainsExamples.publica[1],
            };
        }
      };

      // default options for AllowedAdomainsState for each exception
      const chips: Array<ISimpleOption> = [
        {
          key: 'AllowedAdomainsState',
          value: String(BrandSafetyRuleTargetingAdomainExceptionStateExactMatch),
          label: ct('ExactMatch'),
        },
        {
          key: 'AllowedAdomainsState',
          value: String(BrandSafetyRuleTargetingAdomainExceptionStateContains),
          label: ct('Contains'),
        },
        {
          key: 'AllowedAdomainsState',
          value: String(BrandSafetyRuleTargetingAdomainExceptionStateAllowAll),
          label: ct('AllowAll'),
        },
      ];

      const { classes } = this.props;
      return (
        <Rows>
          {allowedAdomainsState !== BrandSafetyRuleTargetingAdomainExceptionStateAllowAll && (
            <Row noHorizontalPadding paddingTop='0' paddingBottom={spacing.small}>
              {this.renderAdomainTable(tab, idx)}
            </Row>
          )}

          <Row noHorizontalPadding paddingTop='0' paddingBottom={spacing.small}>
            <Cols wrap gap={spacing.extraSmall} style={{ alignItems: 'center' }}>
              {chips
                .filter(
                  (chip: ISimpleOption) =>
                    renderAllowAllOption ||
                    Number(chip.value) !== BrandSafetyRuleTargetingAdomainExceptionStateAllowAll,
                )
                .map((chip: ISimpleOption) => {
                  const val = Number(chip.value);
                  return (
                    <Col>
                      {val === BrandSafetyRuleTargetingAdomainExceptionStateAllowAll ? (
                        <TooltipWithTranslation tKey='BrandSafetyTooltipIncludesBidsWithMissingAdomains'>
                          <Chip
                            label={chip.label}
                            color={allowedAdomainsState === val ? 'primary' : 'default'}
                            onClick={() => {
                              if (idx === undefined) {
                                this.setState({
                                  TargetingAdomainExceptionState: val,
                                });
                                return;
                              }

                              const { BrandSafetyRuleExceptions } = this.state;
                              BrandSafetyRuleExceptions[idx].AllowedAdomainsState = Number(
                                chip.value,
                              );
                              this.setState({
                                BrandSafetyRuleExceptions,
                              });
                            }}
                            style={{ marginBottom: 'unset', marginTop: 'unset' }}
                            disabled={false}
                            className={classes.chip}
                          />
                        </TooltipWithTranslation>
                      ) : (
                        <Chip
                          label={chip.label}
                          color={allowedAdomainsState === val ? 'primary' : 'default'}
                          onClick={() => {
                            if (idx === undefined) {
                              this.setState({
                                TargetingAdomainExceptionState: val,
                              });
                              return;
                            }

                            const { BrandSafetyRuleExceptions } = this.state;
                            BrandSafetyRuleExceptions[idx].AllowedAdomainsState = Number(
                              chip.value,
                            );
                            this.setState({
                              BrandSafetyRuleExceptions,
                            });
                          }}
                          style={{ marginBottom: 'unset', marginTop: 'unset' }}
                          disabled={false}
                          className={classes.chip}
                        />
                      )}
                    </Col>
                  );
                })}
            </Cols>
          </Row>

          {allowedAdomainsState !== BrandSafetyRuleTargetingAdomainExceptionStateAllowAll && (
            <Row noHorizontalPadding paddingTop='0' style={{ maxWidth: '540px' }}>
              <Text
                small
                tKey={
                  allowedAdomainsState === BrandSafetyRuleTargetingAdomainExceptionStateExactMatch
                    ? 'AdomainExactMatchDescription'
                    : 'AdomainContainsDescription'
                }
              />
              <Text
                extraSmall
                muted
                tKey='ExampleTextMatchesAltText'
                tProps={getHelperTextTProps(
                  allowedAdomainsState === BrandSafetyRuleTargetingAdomainExceptionStateExactMatch,
                )}
              />
            </Row>
          )}

          {allowedAdomainsState !== BrandSafetyRuleTargetingAdomainExceptionStateAllowAll && (
            <Row noHorizontalPadding paddingTop='0'>
              <Text
                extraSmall
                muted
                tKey='EnterItemOrUploadCSV'
                tProps={{ item: ct('Adomain') }}
                style={{ marginBottom: spacing.extraSmall }}
              />
              <Cols wrap style={{ alignContent: 'center' }}>
                <Col width='320px' marginRight={spacing.small}>
                  <TextInput
                    key={this.state.reactKey}
                    width='100%'
                    inputSize='small'
                    placeholder={ct('Adomain')}
                    handleOnChange={(input: string) => {
                      const key = isRuleTargetingTab(tab)
                        ? 'adomainUserEntry'
                        : 'adomainUserEntryAllowed';
                      this.setState({
                        [key]: input,
                      });
                    }}
                  />
                </Col>

                <Col displayFlex marginRight={spacing.large} style={{ alignItems: 'center' }}>
                  <TextButton
                    disabled={disabled}
                    onClick={() => {
                      this.addAdomainUserEntry(tab, idx);
                    }}
                  >
                    <Text
                      small
                      tKey='PlusAdd'
                      style={{ color: 'inherit', fontWeight: 'inherit' }}
                    />
                  </TextButton>
                </Col>

                <Col displayFlex marginRight={spacing.large} style={{ alignItems: 'center' }}>
                  <Text tKey='Or' extraSmall muted />
                </Col>

                <Col displayFlex style={{ alignItems: 'center' }}>
                  <label>
                    <TextButton onClick={() => null} style={{ textTransform: 'none' }}>
                      <Text
                        tKey='UploadCSV'
                        small
                        style={{ color: 'inherit', fontWeight: 'inherit' }}
                      />
                    </TextButton>
                    <input
                      type='file'
                      style={{ display: 'none', marginLeft: '20px' }}
                      accept='.csv'
                      onChange={({ target }: React.ChangeEvent<HTMLInputElement>) =>
                        this.handleAdomainCSVFile(target, tab, idx)
                      }
                    />
                  </label>
                </Col>
              </Cols>
            </Row>
          )}
        </Rows>
      );
    }

    // adds the MediafileUserEntry into the Mediafile table
    addMediafileUserEntry(tab: number): void {
      const mediafiles = this.state.mediafiles;
      const mediafileUserEntry = this.state.mediafileUserEntry.toLowerCase();

      // check entry validity
      let snackbarMessage: string = '';
      if (mediafileUserEntry === '') {
        // user entry is empty → error
        snackbarMessage = ct('ErrorEmptyItem', { item: ct('MediafileDomain') });
      } else if (mediafiles.includes(mediafileUserEntry)) {
        // user entry already exists in mediafiles → error
        snackbarMessage = ct('SnackbarItemAlreadyExistWithReasons', {
          item: ct('MediafileDomain'),
          text: mediafileUserEntry,
        });
      } else if (!mediafileDomainRegexp.test(mediafileUserEntry)) {
        // user entry fails domain check → error
        snackbarMessage = ct('ErrorInvalidItem', { item: ct('MediafileDomain') });
      }

      if (snackbarMessage.length > 0) {
        this.setState({
          snackbarError: true,
          snackbarMessage,
        });
      } else if (isRuleTargetingTab(tab)) {
        // add user entry to table data array
        mediafiles.push(mediafileUserEntry);
        // update state
        this.setState({
          mediafiles,
          mediafileUserEntry: '',
          reactKey: this.state.reactKey + 1, // force re-render
        });
      }
    }

    // handles click on the delete button in the language list table
    handleLanguageDelete(tab: number, language: TKey): void {
      if (isRuleTargetingTab(tab)) {
        const newSelectedLanguages = this.state.languages.filter((lang: TKey) => lang !== language);
        this.setState({
          languages: newSelectedLanguages,
          reactKey: this.state.reactKey + 1,
        });
      }
    }

    // ############################## RENDER RULE TYPE LANGUAGE ENTRY COMPONENT ##############################
    renderRuleTypeLanguageEntry(tab: number, disabled: boolean): React.ReactNode {
      const { languages } = this.state;
      return (
        <Rows>
          <Row noHorizontalPadding paddingTop='0'>
            <TableContainer
              component={Paper}
              style={{
                width: '420px',
                boxShadow: 'none',
                borderRadius: borderRadius.base,
                border: `1px solid ${publicaColors.lightGray}`,
                borderBottom: 'none',
              }}
            >
              <Table size='small'>
                <TableHead style={{ backgroundColor: publicaColors.veryLightGray }}>
                  <TableRow>
                    <TableCell>
                      <Text small bold tKey='Language' />
                    </TableCell>
                    <TableCell align='center'>
                      <Text small bold tKey='Delete' />
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {isEmpty(languages) ? (
                    <TableRow>
                      <TableCell>
                        <Text small tKey='None' />
                      </TableCell>
                      <TableCell />
                    </TableRow>
                  ) : (
                    languages.map((language: TKey) => (
                      <TableRow>
                        <TableCell>
                          <Text small tKey={language} />
                        </TableCell>
                        <TableCell align='center'>
                          <Button onClick={() => this.handleLanguageDelete(tab, language)}>
                            <Div
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                              }}
                            >
                              <IconV2 name='delete' large color={publicaColors.gray} />
                            </Div>
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Row>

          <Row noHorizontalPadding paddingTop='0' paddingBottom={spacing.small}>
            <Cols gap='8px'>
              <Col>
                <ActionPill
                  isBlocked
                  isButton
                  isDisabled={false}
                  muted={!this.state.IsTypeTargetingExcluded}
                  onClick={() => this.setState({ IsTypeTargetingExcluded: true })}
                />
              </Col>
              <Col>
                <ActionPill
                  isBlocked={false}
                  isButton
                  isDisabled={false}
                  muted={this.state.IsTypeTargetingExcluded}
                  onClick={() => this.setState({ IsTypeTargetingExcluded: false })}
                />
              </Col>
            </Cols>
          </Row>

          <Row noHorizontalPadding paddingTop='0'>
            <Text small tKey='BrandSafetyTooltipLanguage' />
          </Row>

          <Row noHorizontalPadding paddingTop='0'>
            <Cols gap={spacing.extraSmall} style={{ alignItems: 'center' }}>
              <Col>
                <Text extraSmall muted tKey='SelectItem' tProps={{ item: ct('Language') }} />
              </Col>
              <Col>
                <TooltipWithTranslation tKey='BrandSafetyTooltipLanguage'>
                  <div>
                    <IconV2 small name='info' color={publicaColors.mediumGray} />
                  </div>
                </TooltipWithTranslation>
              </Col>
            </Cols>

            <IndependentSelectV2
              isDisabled={disabled}
              key={this.state.reactKey}
              selectKey='Language'
              labelTKey='Languages'
              disableSearch
              selectedLimit={this.state.languageOptions.length}
              handleApplySelect={(options: Set<string>) =>
                this.setState({ languages: [...options] as TKey[] })
              }
              options={this.state.languageOptions}
              selectedOptionIDs={new Set(languages)}
              maxWidth={240}
            />
          </Row>
        </Rows>
      );
    }

    handleLanguageAcceptClick(list: IMenuList): void {
      const selectedLanguages = [] as TKey[];

      Object.entries(list).forEach(([key, value]) => {
        // if the language is selected, add it to the selectedLanguages array
        if (value.selected) {
          selectedLanguages.push(key as TKey);
        }
      });

      this.setState({
        languages: selectedLanguages,
      });
    }

    // handles user's selected adomain CSV file
    handleMediafileCSVFile(target: EventTarget & HTMLInputElement, tab: number): void {
      // check input
      if (!target.files || target.files.length === 0) {
        return; // no files selected → do nothing
      }
      const file = target.files[0];
      // read file
      const fr = new FileReader();
      fr.onload = (ev: ProgressEvent<FileReader>) => this.digestMediafileCSVFile(ev, tab);
      fr.readAsText(file);
    }

    digestMediafileCSVFile(ev: ProgressEvent<FileReader>, tab: number): void {
      const stateMediafiles = this.state.mediafiles;
      // check target value
      if (ev.target === null) {
        return;
      }
      const content = ev.target.result as string;
      const acceptedEntries: string[] = [];
      const failedEntries: string[] = [];
      const duplicateEntries: string[] = [];

      content.split('\n').forEach((line: string, idx: number) => {
        // for each line
        let entry = line;
        // for each CSV entry
        entry = entry.toLowerCase();
        entry = entry.replace('\r', '');
        //  trim quotes (if any)
        if (entry.length >= 1 && (entry[0] === "'" || entry[0] === '"')) {
          entry = entry.slice(1, -1);
        }
        if (stateMediafiles.includes(entry)) {
          // duplicate domain
          duplicateEntries.push((idx + 1).toString());
        } else if (!mediafileDomainRegexp.test(entry)) {
          // invalid domain
          failedEntries.push((idx + 1).toString());
        } else {
          // valid domain
          acceptedEntries.push(entry);
        }
      });
      // used in snackbarMessage
      const listFailedEntries: string = failedEntries.join(', ');
      const listDuplicateEntries: string = duplicateEntries.join(', ');
      let snackbarMessage: string = '';
      if (failedEntries.length > 0) {
        snackbarMessage += ct('ErrorInvalidMediafilesInCSVFileWithReasons', {
          text: listFailedEntries,
        });
      }

      if (duplicateEntries.length > 0) {
        if (snackbarMessage !== '') snackbarMessage += ' ';
        snackbarMessage += ct('ErrorDuplicateMediafilesInCSVFileWithReasons', {
          text: listDuplicateEntries,
        });
      }

      // refresh state
      if (failedEntries.length > 0 || duplicateEntries.length > 0) {
        const mediafiles = stateMediafiles;
        this.setState({
          mediafiles,
          snackbarError: true,
          snackbarMessage,
          mediafileUserEntry: '',
        });
      } else if (isRuleTargetingTab(tab)) {
        const mediafiles = stateMediafiles.concat(acceptedEntries);
        this.setState({
          mediafiles,
        });
      }
    }

    // handles click on the delete button in the mediafiles list table
    handleMediafileDelete(index: number, tab: number): void {
      // remove element in list
      if (isRuleTargetingTab(tab)) {
        this.setState({
          mediafiles: update(this.state.mediafiles, { $splice: [[index, 1]] }) as string[],
        });
      }
    }

    // ############################## RENDER RULE TYPE MEDIAFILE TABLE ##############################
    renderMediafileTable(tab: number): ReactElement {
      const mediafiles = this.state.mediafiles;
      return (
        <TableContainer
          component={Paper}
          style={{
            width: '720px',
            boxShadow: 'none',
            borderRadius: borderRadius.base,
            border: `1px solid ${publicaColors.lightGray}`,
            borderBottom: 'none',
          }}
        >
          <Table size='small'>
            <TableHead style={{ backgroundColor: publicaColors.veryLightGray }}>
              <TableRow>
                <TableCell>
                  <Text small bold tKey='Mediafile' />
                </TableCell>
                <TableCell align='center'>
                  <Text small bold tKey='Delete' />
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isEmpty(mediafiles) ? (
                <TableRow>
                  <TableCell>
                    <Text small tKey='None' />
                  </TableCell>
                  <TableCell />
                </TableRow>
              ) : (
                mediafiles.map((mediafile: string, index: number) => (
                  <TableRow>
                    <TableCell>
                      <Text style={{ wordBreak: 'break-all' }}>{mediafile}</Text>
                    </TableCell>
                    <TableCell align='center'>
                      <ButtonV2
                        clearBackground
                        onClick={() => this.handleMediafileDelete(index, tab)}
                      >
                        <Div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <IconV2 name='delete' large color={publicaColors.gray} />
                        </Div>
                      </ButtonV2>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      );
    }

    // ############################## RENDER RULE TYPE MEDIAFILE ENTRY COMPONENT ##############################
    renderRuleTypeMediafileEntry(tab: number, disabled: boolean): React.ReactNode {
      return (
        <Rows>
          <Row noHorizontalPadding paddingTop='0' paddingBottom={spacing.small}>
            {this.renderMediafileTable(tab)}
          </Row>

          <Row noHorizontalPadding paddingTop='0' paddingBottom={spacing.large}>
            <Text small tKey='BrandSafetyMediafileRuleTypeDescription' />
          </Row>

          <Row noHorizontalPadding paddingTop='0'>
            <Text
              extraSmall
              muted
              tKey='EnterItemOrUploadCSV'
              tProps={{ item: ct('Mediafile') }}
              style={{ marginBottom: spacing.extraSmall }}
            />
            <Cols wrap style={{ alignContent: 'center' }}>
              <Col width='320px' marginRight={spacing.small}>
                <TextInput
                  key={this.state.reactKey}
                  width='100%'
                  inputSize='small'
                  placeholder={ct('Mediafile')}
                  handleOnChange={(input: string) => {
                    this.setState({
                      mediafileUserEntry: input,
                    });
                  }}
                />
              </Col>

              <Col displayFlex marginRight={spacing.large} style={{ alignItems: 'center' }}>
                <TextButton
                  disabled={disabled}
                  onClick={() => {
                    this.addMediafileUserEntry(tab);
                  }}
                >
                  <Text small tKey='PlusAdd' style={{ color: 'inherit', fontWeight: 'inherit' }} />
                </TextButton>
              </Col>

              <Col displayFlex marginRight={spacing.large} style={{ alignItems: 'center' }}>
                <Text tKey='Or' extraSmall muted />
              </Col>

              <Col displayFlex style={{ alignItems: 'center' }}>
                <label>
                  <TextButton onClick={() => null} style={{ textTransform: 'none' }}>
                    <Text
                      tKey='UploadCSV'
                      small
                      style={{ color: 'inherit', fontWeight: 'inherit' }}
                    />
                  </TextButton>
                  <input
                    type='file'
                    style={{ display: 'none', marginLeft: '20px' }}
                    accept='.csv'
                    onChange={({ target }: React.ChangeEvent<HTMLInputElement>) =>
                      this.handleMediafileCSVFile(target, tab)
                    }
                  />
                </label>
              </Col>
            </Cols>
          </Row>
        </Rows>
      );
    }

    // adds the creativeIDEntry into the creative ids table
    addCreativeIDUserEntry(tab: number): void {
      const creativeIDs = this.state.creativeIDs;
      const creativeIDUserEntry = this.state.creativeIDUserEntry.toLowerCase();

      // check entry validity
      let snackbarMessage: string = '';
      if (creativeIDUserEntry === '') {
        // user entry is empty → error
        snackbarMessage = ct('ErrorEmptyItem', { item: ct('CreativeID') });
      } else if (creativeIDs.includes(creativeIDUserEntry)) {
        // user entry already exists in creative ids → error
        snackbarMessage = ct('SnackbarItemAlreadyExistWithReasons', {
          item: ct('CreativeID'),
          text: creativeIDUserEntry,
        });
      }

      if (snackbarMessage.length > 0) {
        this.setState({
          snackbarError: true,
          snackbarMessage,
        });
      } else if (isRuleTargetingTab(tab)) {
        // add user entry to table data array
        creativeIDs.push(creativeIDUserEntry);
        // update state
        this.setState({
          creativeIDs,
          creativeIDUserEntry: '',
          reactKey: this.state.reactKey + 1, // force re-render
        });
      }
    }

    // handles user's selected creative ids CSV file
    handleCreativeIDCSVFile(target: EventTarget & HTMLInputElement, tab: number): void {
      // check input
      if (!target.files || target.files.length === 0) {
        return; // no files selected → do nothing
      }
      const file = target.files[0];
      // read file
      const fr = new FileReader();
      fr.onload = (ev: ProgressEvent<FileReader>) => this.digestCreativeIDCSVFile(ev, tab);
      fr.readAsText(file);
    }

    digestCreativeIDCSVFile(ev: ProgressEvent<FileReader>, tab: number): void {
      const stateCreativeIDs = this.state.creativeIDs;
      // check target value
      if (ev.target === null) {
        return;
      }
      const content = ev.target.result as string;
      const acceptedEntries: string[] = [];
      const duplicateEntries: string[] = [];

      content.split('\n').forEach((line: string, idx: number) => {
        // for each line
        let entry = line;
        // for each CSV entry
        entry = entry.toLowerCase();
        entry = entry.replace('\r', '');
        //  trim quotes (if any)
        if (entry.length >= 1 && (entry[0] === "'" || entry[0] === '"')) {
          entry = entry.slice(1, -1);
        }
        if (stateCreativeIDs.includes(entry)) {
          // duplicate creative id
          duplicateEntries.push((idx + 1).toString());
        } else {
          // valid creative
          acceptedEntries.push(entry);
        }
      });
      // used in snackbarMessage
      const listDuplicateEntries: string = duplicateEntries.join(', ');
      let snackbarMessage: string = '';
      if (duplicateEntries.length > 0) {
        snackbarMessage = ct('SnackbarItemAlreadyExistWithReasons', {
          text: listDuplicateEntries,
        });
      }

      // refresh state
      if (duplicateEntries.length > 0) {
        const creativeIDs = stateCreativeIDs;
        this.setState({
          creativeIDs,
          snackbarError: true,
          snackbarMessage,
          creativeIDUserEntry: '',
        });
      } else if (isRuleTargetingTab(tab)) {
        const creativeIDs = stateCreativeIDs.concat(acceptedEntries);
        this.setState({
          creativeIDs,
        });
      }
    }

    // handles click on the delete button in the creativeID list table
    handleCreativeIDDelete(index: number, tab: number): void {
      // remove element in list
      if (isRuleTargetingTab(tab)) {
        this.setState({
          creativeIDs: update(this.state.creativeIDs, { $splice: [[index, 1]] }) as string[],
        });
      }
    }

    // ############################## RENDER RULE TYPE CREATIVEID TABLE ##############################
    renderCreativeIDTable(tab: number): ReactElement {
      const creativeIDs = this.state.creativeIDs;
      return (
        <TableContainer
          component={Paper}
          style={{
            width: '420px',
            boxShadow: 'none',
            borderRadius: borderRadius.base,
            border: `1px solid ${publicaColors.lightGray}`,
            borderBottom: 'none',
          }}
        >
          <Table size='small'>
            <TableHead style={{ backgroundColor: publicaColors.veryLightGray }}>
              <TableRow>
                <TableCell>
                  <Text small bold tKey='CreativeID' />
                </TableCell>
                <TableCell align='center'>
                  <Text small bold tKey='Delete' />
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isEmpty(creativeIDs) ? (
                <TableRow>
                  <TableCell>
                    <Text small tKey='None' />
                  </TableCell>
                  <TableCell />
                </TableRow>
              ) : (
                creativeIDs.map((creativeIDs: string, index: number) => (
                  <TableRow>
                    <TableCell>
                      <Text style={{ wordBreak: 'break-all' }}>{creativeIDs}</Text>
                    </TableCell>
                    <TableCell>
                      <ButtonV2
                        clearBackground
                        onClick={() => this.handleCreativeIDDelete(index, tab)}
                      >
                        <Div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <IconV2 name='delete' large color={publicaColors.gray} />
                        </Div>
                      </ButtonV2>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      );
    }

    // ############################## RENDER RULE TYPE CREATIVE ID ENTRY COMPONENT ##############################
    renderRuleTypeCreativeIDEntry(tab: number, disabled: boolean): ReactElement {
      return (
        <Rows>
          <Row noHorizontalPadding paddingTop='0' paddingBottom={spacing.small}>
            {this.renderCreativeIDTable(tab)}
          </Row>

          <Row noHorizontalPadding paddingTop='0' paddingBottom={spacing.large}>
            <Text small tKey='CreativeIDCheckedForExactMatch' />
          </Row>

          <Row noHorizontalPadding paddingTop='0'>
            <Text
              extraSmall
              muted
              tKey='EnterItemOrUploadCSV'
              tProps={{ item: ct('CreativeID') }}
              style={{ marginBottom: spacing.extraSmall }}
            />
            <Cols wrap style={{ alignContent: 'center' }}>
              <Col width='320px' marginRight={spacing.small}>
                <TextInput
                  key={this.state.reactKey}
                  width='100%'
                  inputSize='small'
                  placeholder={ct('CreativeID')}
                  handleOnChange={(input: string) => {
                    this.setState({
                      creativeIDUserEntry: input,
                    });
                  }}
                />
              </Col>

              <Col displayFlex marginRight={spacing.large} style={{ alignItems: 'center' }}>
                <TextButton disabled={disabled} onClick={() => this.addCreativeIDUserEntry(tab)}>
                  <Text small tKey='PlusAdd' style={{ color: 'inherit', fontWeight: 'inherit' }} />
                </TextButton>
              </Col>

              <Col displayFlex marginRight={spacing.large} style={{ alignItems: 'center' }}>
                <Text tKey='Or' extraSmall muted />
              </Col>

              <Col displayFlex style={{ alignItems: 'center' }}>
                <label>
                  <TextButton onClick={() => null} style={{ textTransform: 'none' }}>
                    <Text
                      tKey='UploadCSV'
                      small
                      style={{ color: 'inherit', fontWeight: 'inherit' }}
                    />
                  </TextButton>
                  <input
                    type='file'
                    style={{ display: 'none', marginLeft: '20px' }}
                    accept='.csv'
                    onChange={({ target }: React.ChangeEvent<HTMLInputElement>) =>
                      this.handleCreativeIDCSVFile(target, tab)
                    }
                  />
                </label>
              </Col>
            </Cols>
          </Row>
        </Rows>
      );
    }

    // adds the eventTrackerDEntry into the event trackers table
    addEventTrackerUserEntry(tab: number): void {
      const eventTrackers = [...this.state.eventTrackers];
      let eventTrackerUserEntry = this.state.eventTrackerUserEntry.toLowerCase();
      eventTrackerUserEntry = getDomain(eventTrackerUserEntry) as string;
      // check entry validity
      let snackbarMessage: string = '';
      if (eventTrackerUserEntry.length === 0) {
        // user entry is empty → error
        snackbarMessage = ct('ErrorEmptyItem', { item: ct('EventTracker') });
      } else if (eventTrackers.includes(eventTrackerUserEntry)) {
        // user entry already exists in event trackers → error
        snackbarMessage = ct('SnackbarItemAlreadyExistWithReasons', {
          item: ct('EventTracker'),
          text: eventTrackerUserEntry,
        });
      } else if (!mediafileDomainRegexp.test(eventTrackerUserEntry)) {
        // user entry fails event tracker check → error
        snackbarMessage = ct('ErrorInvalidItem', { item: ct('EventTracker') });
      }

      if (snackbarMessage.length > 0) {
        this.setState({
          snackbarError: true,
          snackbarMessage,
        });
      } else if (isRuleTargetingTab(tab)) {
        // add entry to table data array
        eventTrackers.push(eventTrackerUserEntry);
        // update state
        this.setState({
          eventTrackers,
          eventTrackerUserEntry: '',
          reactKey: this.state.reactKey + 1,
        });
      }
    }

    // handles click on the delete button in the event tracker list table
    handleEventTrackerDelete(index: number, tab: number): void {
      // remove element in list
      if (isRuleTargetingTab(tab)) {
        this.setState({
          eventTrackers: update(this.state.eventTrackers, { $splice: [[index, 1]] }) as string[],
        });
      }
    }

    // handles user's selected event trackers CSV file
    handleEventTrackerCSVFile(target: EventTarget & HTMLInputElement, tab: number): void {
      // check input
      if (!target.files || target.files.length === 0) {
        return; // no files selected → do nothing
      }
      const file = target.files[0];
      // read file
      const fr = new FileReader();
      fr.onload = (ev: ProgressEvent<FileReader>) => this.digestEventTrackerCSVFile(ev, tab);
      fr.readAsText(file);
    }

    digestEventTrackerCSVFile(ev: ProgressEvent<FileReader>, tab: number): void {
      const stateEventTrackers = this.state.eventTrackers;
      // check target value
      if (ev.target === null) {
        return;
      }
      const content = ev.target.result as string;
      const acceptedEntries: string[] = [];
      const failedEntries: string[] = [];
      const duplicateEntries: string[] = [];

      content.split('\n').forEach((line: string, idx: number) => {
        // for each line
        let entry = line;
        // for each CSV entry
        entry = entry.toLowerCase();
        entry = entry.replace('\r', '');
        //  trim quotes (if any)
        if (entry.length >= 1 && (entry[0] === "'" || entry[0] === '"')) {
          entry = entry.slice(1, -1);
        }
        entry = getDomain(entry) as string;
        if (stateEventTrackers.includes(entry)) {
          // duplicate creative id
          duplicateEntries.push((idx + 1).toString());
        } else if (!mediafileDomainRegexp.test(entry)) {
          // invalid event tracker
          failedEntries.push((idx + 1).toString());
        } else {
          // valid creative
          acceptedEntries.push(entry);
        }
      });

      // used in snackbarMessage
      const listFailedEntries: string = failedEntries.join(', ');
      const listDuplicateEntries: string = duplicateEntries.join(', ');
      let snackbarMessage: string = '';
      if (failedEntries.length > 0) {
        snackbarMessage += ct('ErrorInvalidEventTrackersInCSVFileWithReasons', {
          text: listFailedEntries,
        });
      }
      if (duplicateEntries.length > 0) {
        if (snackbarMessage !== '') snackbarMessage += ' ';
        snackbarMessage += ct('ErrorDuplicateEventTrackersInCSVFileWithReasons', {
          text: listDuplicateEntries,
        });
      }

      // refresh state
      if (failedEntries.length > 0 || duplicateEntries.length > 0) {
        this.setState({
          snackbarError: true,
          snackbarMessage,
          creativeIDUserEntry: '',
        });
      } else if (isRuleTargetingTab(tab)) {
        this.setState({
          eventTrackers: stateEventTrackers.concat(acceptedEntries),
        });
      }
    }

    // ############################## RENDER RULE TYPE EVENTTRACKER TABLE ##############################
    renderEventTrackerTable(tab: number): ReactElement {
      const { eventTrackers } = this.state;
      return (
        <TableContainer
          component={Paper}
          style={{
            width: '420px',
            boxShadow: 'none',
            borderRadius: borderRadius.base,
            border: `1px solid ${publicaColors.lightGray}`,
            borderBottom: 'none',
          }}
        >
          <Table size='small'>
            <TableHead style={{ backgroundColor: publicaColors.veryLightGray }}>
              <TableRow>
                <TableCell>
                  <Text tKey='EventTracker' small bold />
                </TableCell>
                <TableCell align='center'>
                  <Text tKey='Delete' small bold />
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {isEmpty(eventTrackers) ? (
                <TableRow>
                  <TableCell>
                    <Text tKey='None' />
                  </TableCell>
                  <TableCell />
                </TableRow>
              ) : (
                eventTrackers.map((eventTracker: string, index: number) => (
                  <TableRow>
                    <TableCell>
                      <Text>{eventTracker}</Text>
                    </TableCell>
                    <TableCell align='center'>
                      <ButtonV2
                        clearBackground
                        onClick={() => this.handleEventTrackerDelete(index, tab)}
                      >
                        <Div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <IconV2 name='delete' large color={publicaColors.gray} />
                        </Div>
                      </ButtonV2>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      );
    }

    // ############################## RENDER RULE TYPE EVENT TRACKER ENTRY COMPONENT ##############################
    renderRuleTypeEventTrackerEntry(tab: number, disabled: boolean): ReactElement {
      return (
        <Rows>
          <Row noHorizontalPadding paddingTop='0' paddingBottom={spacing.large}>
            {this.renderEventTrackerTable(tab)}
          </Row>

          <Row noHorizontalPadding paddingTop='0' paddingBottom={spacing.large}>
            <Text small tKey='BrandSafetyEventTrackerRuleTypeDescription' />
          </Row>

          <Row noHorizontalPadding paddingTop='0'>
            <Text
              extraSmall
              muted
              tKey='EnterItemOrUploadCSV'
              tProps={{ item: ct('EventTracker') }}
              style={{ marginBottom: spacing.extraSmall }}
            />
            <Cols wrap style={{ alignContent: 'center' }}>
              <Col width='320px' marginRight={spacing.small}>
                <TextInput
                  key={this.state.reactKey}
                  width='100%'
                  inputSize='small'
                  placeholder={ct('EventTracker')}
                  handleOnChange={(input: string) =>
                    this.setState({ eventTrackerUserEntry: input })
                  }
                />
              </Col>

              <Col displayFlex marginRight={spacing.large} style={{ alignItems: 'center' }}>
                <TextButton disabled={disabled} onClick={() => this.addEventTrackerUserEntry(tab)}>
                  <Text small tKey='PlusAdd' style={{ color: 'inherit', fontWeight: 'inherit' }} />
                </TextButton>
              </Col>

              <Col displayFlex marginRight={spacing.large} style={{ alignItems: 'center' }}>
                <Text tKey='Or' extraSmall muted />
              </Col>

              <Col displayFlex style={{ alignItems: 'center' }}>
                <label>
                  <TextButton onClick={() => null} style={{ textTransform: 'none' }}>
                    <Text
                      tKey='UploadCSV'
                      small
                      style={{ color: 'inherit', fontWeight: 'inherit' }}
                    />
                  </TextButton>
                  <input
                    type='file'
                    style={{ display: 'none', marginLeft: '20px' }}
                    accept='.csv'
                    onChange={({ target }: React.ChangeEvent<HTMLInputElement>) =>
                      this.handleEventTrackerCSVFile(target, tab)
                    }
                  />
                </label>
              </Col>
            </Cols>
          </Row>
        </Rows>
      );
    }

    // ############################## RENDER RULE TYPE IAB ENTRY COMPONENT ##############################
    renderRuleTypeIABEntry(tab: number, disabled?: boolean, idx?: number): ReactElement {
      const iabList = isRuleTargetingTab(tab)
        ? this.state.iabList
        : (this.state.iabListAllowed as IIABCategoryTableItems[]);
      const selectedIABPrefix = isRuleTargetingTab(tab)
        ? (this.state.userEntryIABPrefix as IABCategory)
        : (this.state.userEntryIABPrefixAllowed as IABCategory);
      const selectedIABSuffix = isRuleTargetingTab(tab)
        ? this.state.userEntryIABSuffix
        : this.state.userEntryIABSuffixAllowed;

      return (
        <Rows>
          <Row noHorizontalPadding paddingTop='0' paddingBottom={spacing.large}>
            <IABCategoryTable
              list={iabList}
              brandSafetyRuleExceptions={this.state.BrandSafetyRuleExceptions}
              isException={tab === RuleExceptionTab}
              handleChange={(newList: IIABCategoryTableItems[], title: string) =>
                this.handleChangeRuleTypeIABEntry(tab, newList, title, idx, disabled)
              }
              handleOpenRuleTargetedExceptionDialog={(targetedExceptionIABCode: string) =>
                this.handleOpenRuleTargetedExceptionDialog(targetedExceptionIABCode)
              }
            />
          </Row>

          <Row noHorizontalPadding paddingTop='0'>
            <Cols wrap style={{ alignContent: 'center' }}>
              <Col width='15rem' marginRight={spacing.small}>
                <Text
                  extraSmall
                  muted
                  tKey='IABCategory'
                  style={{ marginBottom: spacing.extraSmall }}
                />
              </Col>
              <Col width='15rem' marginRight={spacing.small}>
                <Text
                  extraSmall
                  muted
                  tKey='IABSubcategory'
                  style={{ marginBottom: spacing.extraSmall }}
                />
              </Col>
            </Cols>

            <Cols wrap style={{ alignContent: 'center' }}>
              <Col width='15rem' marginRight={spacing.small}>
                <SimpleSingleSelect
                  inputWidth='15rem'
                  placeholder={ct('SelectItem', { item: ct('IABCategory') })}
                  onChange={(key: string) => {
                    this.setState({
                      [isRuleTargetingTab(tab)
                        ? 'userEntryIABPrefix'
                        : 'userEntryIABPrefixAllowed']: key,
                    });
                  }}
                  options={Object.entries(IABCategoryToTKey).map(
                    ([key, value]: [IABCategory, TKey]) => {
                      return {
                        key,
                        label: `${key}: ${ct(value)}`,
                        value: key,
                        isSelected: !!(selectedIABPrefix && key === selectedIABPrefix),
                      };
                    },
                  )}
                  popoverWidth='15rem'
                />
              </Col>

              <Col width='15rem' marginRight={spacing.small}>
                <SimpleSingleSelect
                  inputWidth='15rem'
                  placeholder={ct('SelectItem', { item: ct('IABSubcategory') })}
                  isDisabled={!selectedIABPrefix}
                  onChange={(key: string) => {
                    this.setState({
                      [isRuleTargetingTab(tab)
                        ? 'userEntryIABSuffix'
                        : 'userEntryIABSuffixAllowed']: key,
                    });
                  }}
                  options={
                    selectedIABPrefix
                      ? Object.entries(IABSubcategoryToTKey[selectedIABPrefix]).map(
                          ([key, value]: [IABCategory, TKey]) => {
                            return {
                              key,
                              label: `${key}: ${ct(value)}`,
                              value: key,
                              isSelected: !!(selectedIABSuffix && key === selectedIABSuffix),
                            };
                          },
                        )
                      : []
                  }
                  popoverWidth='12.5rem'
                />
              </Col>

              <Col displayFlex style={{ alignItems: 'center' }}>
                <TextButton disabled={disabled} onClick={() => this.addIABUserEntry(tab, idx)}>
                  <Text small tKey='PlusAdd' style={{ color: 'inherit', fontWeight: 'inherit' }} />
                </TextButton>
              </Col>
            </Cols>
          </Row>

          <Row noPadding paddingBottom={spacing.extraSmall}>
            <Text tKey='Or' extraSmall muted />
          </Row>

          <Row noHorizontalPadding paddingTop='0'>
            <Cols wrap style={{ alignContent: 'center' }}>
              <Col width={'20rem'} marginRight={spacing.small}>
                <TextInput
                  key={this.state.reactKey}
                  width='100%'
                  inputSize='small'
                  placeholder={ct('PlaceholderEnterItemCommaSeparatedHere', {
                    item: ct('IABCategory'),
                  })}
                  handleOnChange={(input: string) => {
                    this.setState({
                      [isRuleTargetingTab(tab) ? 'userEntryIABList' : 'userEntryIABListAllowed']:
                        input,
                    });
                  }}
                />
              </Col>
              <Col displayFlex style={{ alignItems: 'center' }}>
                <TextButton
                  disabled={disabled}
                  onClick={() => {
                    this.addIABUserEntry(tab, idx);
                  }}
                >
                  <Text small tKey='PlusAdd' style={{ color: 'inherit', fontWeight: 'inherit' }} />
                </TextButton>
              </Col>
            </Cols>
          </Row>
        </Rows>
      );
    }

    // return a promise that deletes a rule in the API
    deleteRuleWithPromise(ruleID: number): Promise<IHttpResponse<IBrandSafetyRule>> {
      // build request URL
      const reqURL = createUrl(`/brandsafetyrules/${ruleID}`, this.props.session.publisher.ID);
      // return the request's promise
      return restDelete<IBrandSafetyRule>(reqURL, null);
    }

    // generates the active tags for comma sep values for the accordions (i.e. 2 IDs, 4 Producers)
    // fieldValue represents the textfield (contentid1, contentid2, contentid3) and
    // fieldName represents the name to be shown (Content ID)
    // multi-accordion-panel will ignore an empty string active tag
    generateActiveTagForCommaSepField = (fieldValue: string, fieldName: TKey): string => {
      if (fieldValue && fieldValue.length > 0) {
        // split the field and get rid of empty strings to count
        const count = fieldValue.split(',').filter((part: string) => part !== '').length;
        return ct('FormatLabelWithCount', { label: ct(fieldName), count });
      }
      return '';
    };

    // display a the list of string if result string is below maxStrLength characters
    // else display the number of elements instead
    truncateListIfTooLong(list: string[], maxStrLength: number, name: string): string {
      const listAsStr = list.join(', ');
      if (listAsStr.length > maxStrLength) {
        // string is too long, return number of elements
        return `${list.length} ${name}` + (list.length > 1 ? 's' : '');
      }
      // string length is okay, return it
      return listAsStr;
    }

    // ############################## RENDER IAB SUMMARY FOR RULE SUMMARY ##############################
    renderIABSummary(): ReactElement {
      return (
        <>
          {/* BLOCKED LIST*/}
          <Grid
            container
            direction='column'
            justify='flex-start'
            alignItems='flex-start'
            spacing={1}
            style={{ marginTop: '0px' }}
          >
            <Grid
              item
              style={{
                fontWeight: 500,
                color: publicaColors.darkGray,
              }}
            >
              Blocked
            </Grid>
            <Grid item style={{ marginBottom: 15 }}>
              {
                // print list of blocked IAB
                this.truncateListIfTooLong(
                  this.state.iabList.filter((e) => e.included).map((e) => e.title),
                  23,
                  'IAB',
                )
              }
            </Grid>
          </Grid>
          {/* ALLOWED LIST*/}
          <Grid
            container
            direction='column'
            justify='flex-start'
            alignItems='flex-start'
            spacing={1}
            style={{ marginTop: '0px' }}
          >
            <Grid
              item
              style={{
                fontWeight: 500,
                color: publicaColors.darkGray,
              }}
            >
              Allowed
            </Grid>
            <Grid item>
              {
                // print list of blocked IAB
                this.truncateListIfTooLong(
                  this.state.iabList.filter((e) => !e.included).map((e) => e.title),
                  23,
                  'IAB',
                )
              }
            </Grid>
          </Grid>
        </>
      );
    }

    renderBrandSafetyRuleTargeting = (): ReactElement => {
      const { hasWriteCurrentRuleRight, RuleTargetingType } = this.state;
      // App Panel & Rows
      const appBundleRow: IInputRow = {
        renderType: 'TextfieldAndIncludeV2',
        title1: ct('AppBundleID'),
        field1: 'TargetedAppBundleID',
        value1: this.state.TargetedAppBundleID,
        handleChange1: (input: string) =>
          this.handleChange({
            target: { name: 'TargetedAppBundleID', value: input },
          }),
        isActiveValue1: () => this.state.TargetedAppBundleID.length > 0,
        getActiveTag1: () =>
          this.generateActiveTagForCommaSepField(this.state.TargetedAppBundleID, 'AppBundleIDs'),
        value2: this.state.TargetedAppBundleIDIsAllowed === EAllowStatus.ALLOW,
        handleChange2: () =>
          this.handleChange({
            target: {
              name: 'TargetedAppBundleIDIsAllowed',
              value:
                this.state.TargetedAppBundleIDIsAllowed === EAllowStatus.ALLOW
                  ? EAllowStatus.DENY
                  : EAllowStatus.ALLOW,
            },
          }),
        placeholderText: ct('PlaceholderEnterItemCommaSeparatedHere', { item: ct('AppBundleIDs') }),
        tooltipText: (
          <div>
            <Text color={publicaColors.white} mini bold tKey='AppBundleIDDescription' />
            <a
              href='https://iabtechlab.com/wp-content/uploads/2020/08/IAB-Tech-Lab-OTT-store-assigned-App-Identification-Guidelines-2020.pdf'
              rel='noopener'
              target='_blank'
            >
              <Text
                color={publicaColors.white}
                mini
                bold
                tKey='MoreInfo'
                style={{ textDecoration: 'underline' }}
              />
            </a>
          </div>
        ),
      };

      const sitePagesRow: IInputRow = {
        renderType: 'TextfieldAndIncludeV2',
        title1: ct('SitePage'),
        field1: 'TargetedSitePages',
        value1: this.state.TargetedSitePages,
        handleChange1: (input: string) =>
          this.handleChange({
            target: { name: 'TargetedSitePages', value: input },
          }),
        isActiveValue1: () => this.state.TargetedSitePages.length > 0,
        getActiveTag1: () =>
          this.generateActiveTagForCommaSepField(this.state.TargetedSitePages, 'SitePages'),
        value2: this.state.TargetedSitePagesIsAllowed === EAllowStatus.ALLOW,
        handleChange2: () =>
          this.handleChange({
            target: {
              name: 'TargetedSitePagesIsAllowed',
              value:
                this.state.TargetedSitePagesIsAllowed === EAllowStatus.ALLOW
                  ? EAllowStatus.DENY
                  : EAllowStatus.ALLOW,
            },
          }),
        placeholderText: ct('PlaceholderEnterItemCommaSeparatedHere', { item: ct('SitePages') }),
      };

      const AppPanel = {
        title: ct('App'),
        panelInactiveRowTag: ct('Inactive'),
        panelActiveChipTitle: ct('App'),
        rows: [appBundleRow, sitePagesRow],
      };

      // Content Panel & Rows
      const contentAccordionRows = [
        'ContentChannel',
        'ContentDistributor',
        'ContentGenre',
        'ContentID',
        'ContentNetwork',
        'ContentProducer',
        'ContentRating',
        'ContentSeries',
        'ContentTitle',
      ].map((fieldName: TKey) => {
        const contentFieldName = `Targeted${fieldName}`;
        const contentFieldIsAllowedName = `Targeted${fieldName}IsAllowed`;
        const contentFieldIsAllowed = this.state[contentFieldIsAllowedName] === EAllowStatus.ALLOW;
        return {
          renderType: 'TextfieldAndIncludeV2',
          tooltipText: ct('ItemToApplyOnCommaSeparated', { item: ct(fieldName) }),
          title1: ct(fieldName),
          field1: contentFieldName,
          value1: this.state[contentFieldName] as string,
          handleChange1: (input: string) =>
            this.handleChange({
              target: { name: contentFieldName, value: input },
            }),
          isActiveValue1: () => (this.state[contentFieldName] as string).length > 0,
          getActiveTag1: () =>
            this.generateActiveTagForCommaSepField(
              this.state[contentFieldName] as string,
              fieldName,
            ),
          value2: contentFieldIsAllowed,
          handleChange2: () =>
            this.handleChange({
              target: {
                name: contentFieldIsAllowedName,
                value:
                  this.state[contentFieldIsAllowedName] === EAllowStatus.ALLOW
                    ? EAllowStatus.DENY
                    : EAllowStatus.ALLOW,
              },
            }),
          placeholderText: ct('PlaceholderEnterItemCommaSeparatedHere', { item: ct(fieldName) }),
        } as IInputRow;
      });

      const ContentPanel = {
        title: ct('Content'),
        panelInactiveRowTag: ct('None'),
        panelActiveChipTitle: ct('Custom'),
        rows: [...contentAccordionRows],
      } as IAccordionPanel;

      // Custom Panel & Rows (also known as customRows in other places such as Campaign and Bidder)
      const customAccordionRows = [
        'Custom4',
        'Custom5',
        'Custom6',
        'Custom7',
        'Custom8',
        'Custom9',
        'Custom10',
        'Custom11',
        'Custom12',
        'Custom13',
        'Custom14',
        'Custom15',
        'Custom16',
        'Custom17',
        'Custom18',
      ].map((fieldName: TKey) => {
        const customFieldName = `Targeted${fieldName}`;
        const customFieldIsAllowedName = `Targeted${fieldName}IsAllowed`;
        const customFieldIsAllowed = this.state[customFieldIsAllowedName] === EAllowStatus.ALLOW;
        return {
          renderType: 'TextfieldAndIncludeV2',
          tooltipText: ct('ItemToApplyOnCommaSeparated', { item: ct(fieldName) }),
          title1: ct(fieldName),
          field1: customFieldName,
          value1: this.state[customFieldName] as string,
          handleChange1: (input: string) =>
            this.handleChange({
              target: { name: customFieldName, value: input },
            }),
          isActiveValue1: () => (this.state[customFieldName] as string).length > 0,
          getActiveTag1: () =>
            this.generateActiveTagForCommaSepField(
              this.state[customFieldName] as string,
              fieldName,
            ),
          value2: customFieldIsAllowed,
          handleChange2: () =>
            this.handleChange({
              target: {
                name: customFieldIsAllowedName,
                value:
                  this.state[customFieldIsAllowedName] === EAllowStatus.ALLOW
                    ? EAllowStatus.DENY
                    : EAllowStatus.ALLOW,
              },
            }),
          placeholderText: ct('PlaceholderEnterItemCommaSeparatedHere', { item: ct(fieldName) }),
          optionalIcon: fieldName === 'Targeting' ? 'flag' : null,
          optionalIconInfo: fieldName === 'Targeting' ? ct('NotIncludedInForecast') : null,
        } as IInputRow;
      });

      const CustomPanel = {
        title: ct('Custom'),
        panelInactiveRowTag: ct('None'),
        panelActiveChipTitle: ct('Custom'),
        rows: [...customAccordionRows],
      } as IAccordionPanel;

      // GEO PANEL AND ROWS
      const countriesCount = Object.values(this.state.targetingCountriesList).filter(
        (item: IListItem) => item.selected,
      ).length;
      const countryGroupCount = Object.values(this.state.targetingCountryGroupList).filter(
        (item: IListItem) => item.selected,
      ).length;

      const TargetedRegionsRow: IInputRow = {
        renderType: 'custom',
        customRender: () => {
          return this.renderAllRegionsDialog({
            renderType: 'MaterialDropdown',
            title1: ct('TargetedRegions'),
            field1: 'TargetingCountryGroupIDs',
            value1: this.state.targetingCountryGroupList,
            handleChange1: this.handleChangeList('targetingCountryGroupList'),
            isActiveValue1: () => countryGroupCount > 0,
            getActiveTag1: (active: boolean) => {
              if (!active) {
                return ct('AllItems', { item: ct('Regions') });
              }
              return ct('FormatLabelWithCount', { label: ct('Regions'), count: countryGroupCount });
            },
            value2: this.state.TargetingCountryGroupIDsIsAllowed === EAllowStatus.ALLOW,
            handleChange2: () =>
              this.handleChange({
                target: {
                  name: 'TargetingCountryGroupIDsIsAllowed',
                  value:
                    this.state.TargetingCountryGroupIDsIsAllowed === EAllowStatus.ALLOW
                      ? EAllowStatus.DENY
                      : EAllowStatus.ALLOW,
                },
              }),
            // if no country groups are selected, all country groups are selected by default
            isNoneSelectedAllSelected: true,
            showModalButton: true,
            modalButton: (
              <TextButton
                onClick={() => this.setState({ openRegionSelectTable: true })}
                disabled={!this.state.writeAuthorization.isAuthorized}
                style={{ paddingLeft: spacing.base }}
              >
                <Text
                  small
                  tKey='SeeItem'
                  tProps={{ item: ct('Regions') }}
                  style={{ color: 'inherit', fontWeight: 'inherit' }}
                />
              </TextButton>
            ),
          });
        },
        title1: '',
        isActiveValue1: () => countryGroupCount > 0,
        getActiveTag1: (active: boolean) => {
          if (!active) {
            return ct('AllItems', { item: ct('Regions') });
          }
          return ct('FormatLabelWithCount', { label: ct('Region'), count: countryGroupCount });
        },
      };

      const TargetedCountriesRow: IInputRow = {
        renderType: 'MaterialDropdown',
        title1: ct('TargetedCountries'),
        field1: 'TargetingDeviceCountry',
        value1: this.state.targetingCountriesList,
        handleChange1: this.handleChangeList('targetingCountriesList'),
        handleAccept1: () => null,
        isActiveValue1: () => countriesCount > 0,
        getActiveTag1: (active: boolean) => {
          if (!active) {
            return ct('AllItems', { item: ct('Countries') });
          }
          return ct('FormatLabelWithCount', { label: ct('Countries'), count: countriesCount });
        },
        value2: this.state.TargetingDeviceCountryIsAllowed === EAllowStatus.ALLOW,
        handleChange2: () =>
          this.handleChange({
            target: {
              name: 'TargetingDeviceCountryIsAllowed',
              value:
                this.state.TargetingDeviceCountryIsAllowed === EAllowStatus.ALLOW
                  ? EAllowStatus.DENY
                  : EAllowStatus.ALLOW,
            },
          }),
        // if no countries are selected, all countries are selected (optional material search dropdown param)
        isNoneSelectedAllSelected: true,
      };

      const LocalTargetingAllowedRow: IInputRow = {
        renderType: 'custom',
        customRender: this.renderLocalTargetingAllowedPanel,
        title1: '',
        field1: '',
        value1: this.state.LocalTargetingAllowed,
        handleChange1: noopVoid,
        isActiveValue1: () => this.state.localTargetingAllowedParameters.length !== 0,
        getActiveTag1: (active: boolean) => {
          if (!active) {
            return '';
          }
          return ct('FormatLabelWithCount', {
            label: ct('LocalTargetingIncluded'),
            count: this.state.localTargetingAllowedParameters.length,
          });
        },
      };

      const LocalTargetingDisallowedRow: IInputRow = {
        renderType: 'custom',
        customRender: this.renderLocalTargetingDisallowedPanel,
        title1: '',
        field1: '',
        value1: this.state.LocalTargetingDisallowed,
        handleChange1: noopVoid,
        isActiveValue1: () => this.state.localTargetingDisallowedParameters.length !== 0,
        getActiveTag1: (active: boolean) => {
          if (!active) {
            return '';
          }
          return ct('FormatLabelWithCount', {
            label: ct('LocalTargetingExcluded'),
            count: this.state.localTargetingDisallowedParameters.length,
          });
        },
      };

      const GeoPanel: IAccordionPanel = {
        title: ct('Geo'),
        panelInactiveRowTag: ct('AllItems', { item: ct('Geos') }),
        panelActiveChipTitle: ct('Custom'),
        rows: [
          TargetedRegionsRow,
          TargetedCountriesRow,
          LocalTargetingAllowedRow,
          LocalTargetingDisallowedRow,
        ],
      };

      // Privacy Panel
      const CoppaRow: IInputRow = {
        renderType: 'SimpleSingleSelect',
        simpleSelectItems: generateCOPPAOptions(),
        title1: ct('COPPA'),
        field1: 'TargetedCoppa',
        value1: this.state.TargetedCoppa,
        defaultValue1: TargetingCoppaAll,
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.TargetedCoppa !== TargetingCoppaAll,
        getActiveTag1: (active: boolean) =>
          active ? (this.state.TargetedCoppa === TargetingCoppa0 ? 'COPPA = 0' : 'COPPA = 1') : '',
      };

      const CCPARow: IInputRow = {
        renderType: 'SimpleSingleSelect',
        simpleSelectItems: generateCCPAOptions(),
        title1: ct('CCPA'),
        field1: 'TargetingCCPA',
        value1: this.state.TargetingCCPA,
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.TargetingCCPA !== TargetingCCPAAll,
        getActiveTag1: (active: boolean) => {
          if (!active) return '';
          return this.state.TargetingCCPA !== TargetingCCPAAll
            ? ct('ItemTargeted', { item: ct('CCPA') })
            : ct('AllItems', { item: ct('CCPA') });
        },
      };

      const PrivacyPanel = {
        title: ct('Privacy'),
        panelInactiveRowTag: ct('Inactive'),
        panelActiveChipTitle: ct('Privacy'),
        rows: [CoppaRow, CCPARow],
      };

      // Venue Panel
      const venueRow: IInputRow = {
        renderType: 'TextfieldAndIncludeV2',
        title1: ct('VenueID'),
        field1: 'TargetedVenueID',
        value1: this.state.TargetedVenueID,
        handleChange1: (input: string) =>
          this.handleChange({
            target: { name: 'TargetedVenueID', value: input },
          }),
        isActiveValue1: () => this.state.TargetedVenueID.length > 0,
        getActiveTag1: () =>
          this.generateActiveTagForCommaSepField(this.state.TargetedVenueID, 'VenueIDs'),
        value2: this.state.TargetedVenueIDIsAllowed === EAllowStatus.ALLOW,
        handleChange2: () =>
          this.handleChange({
            target: {
              name: 'TargetedVenueIDIsAllowed',
              value:
                this.state.TargetedVenueIDIsAllowed === EAllowStatus.ALLOW
                  ? EAllowStatus.DENY
                  : EAllowStatus.ALLOW,
            },
          }),
        placeholderText: ct('PlaceholderEnterItemCommaSeparatedHere', { item: ct('VenueID') }),
      };

      const VenuePanel = {
        title: ct('Venue'),
        panelInactiveRowTag: ct('Inactive'),
        panelActiveChipTitle: ct('Venue'),
        rows: [venueRow],
      };

      // DAYPARTING PANEL
      const daypartingRow: IInputRow = {
        renderType: 'custom',
        customRender: this.renderDayparting,
        title1: '',
        field1: '',
        value1: this.state.isDaypartingActive === true,
        defaultValue1: false,
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.isDaypartingActive,
        getActiveTag1: (active: boolean) => {
          return active ? ct('AllItems', { item: ct('Daypartings') }) : ct('None');
        },
      };

      const DaypartingPanel = {
        title: ct('Dayparting'),
        panelInactiveRowTag: ct('AllItems', { item: ct('Daypartings') }),
        panelActiveChipTitle: ct('Custom'),
        rows: [daypartingRow],
      } as IAccordionPanel;

      const multiAccordionPanels = [
        AppPanel,
        ContentPanel,
        CustomPanel,
        DaypartingPanel,
        GeoPanel,
        PrivacyPanel,
        VenuePanel,
      ] as IAccordionPanel[];

      const getLoadingOptions = (): boolean => {
        switch (RuleTargetingType) {
          case BrandSafetyRuleTargetingTypeBidder:
            return this.state.loadingBidderOptions;
          case BrandSafetyRuleTargetingTypeBidderGroup:
            return this.state.loadingBidderGroupOptions;
          case BrandSafetyRuleTargetingTypeChannel:
            return this.state.loadingChannelOptions;
          case BrandSafetyRuleTargetingTypeChannelGroup:
            return this.state.loadingChannelGroupOptions;
          default:
            return false;
        }
      };

      const getOptions = (): ISelectOption[] => {
        switch (RuleTargetingType) {
          case BrandSafetyRuleTargetingTypeBidder:
            return this.state.bidderOptions;
          case BrandSafetyRuleTargetingTypeBidderGroup:
            return this.state.bidderGroupOptions;
          case BrandSafetyRuleTargetingTypeChannel:
            return this.state.channelOptions;
          case BrandSafetyRuleTargetingTypeChannelGroup:
            return this.state.channelGroupOptions;
          default:
            return [] as ISelectOption[];
        }
      };

      const getSelectedIDs = (): number[] => {
        switch (RuleTargetingType) {
          case BrandSafetyRuleTargetingTypeBidder:
            return this.state.selectedBidderIDs;
          case BrandSafetyRuleTargetingTypeBidderGroup:
            return this.state.selectedBidderGroupIDs;
          case BrandSafetyRuleTargetingTypeChannel:
            return this.state.selectedChannelIDs;
          case BrandSafetyRuleTargetingTypeChannelGroup:
            return this.state.selectedChannelGroupIDs;
          default:
            return [] as number[];
        }
      };

      const deselectOtherRuleTypeOptions = (
        ruleTargetingType: number,
      ): Record<string, number[]> => {
        switch (ruleTargetingType) {
          case BrandSafetyRuleTargetingTypeBidder:
            return {
              selectedBidderGroupIDs: [],
              selectedChannelIDs: [],
              selectedChannelGroupIDs: [],
            };
          case BrandSafetyRuleTargetingTypeBidderGroup:
            return {
              selectedBidderIDs: [],
              selectedChannelIDs: [],
              selectedChannelGroupIDs: [],
            };
          case BrandSafetyRuleTargetingTypeChannel:
            return {
              selectedBidderIDs: [],
              selectedBidderGroupIDs: [],
              selectedChannelGroupIDs: [],
            };
          case BrandSafetyRuleTargetingTypeChannelGroup:
            return {
              selectedBidderIDs: [],
              selectedBidderGroupIDs: [],
              selectedChannelIDs: [],
            };
          default:
            return {};
        }
      };

      const updateSelectedIDs = (ruleType: number, ids: number[]): void => {
        switch (ruleType) {
          case BrandSafetyRuleTargetingTypeBidder: {
            this.setState({
              selectedBidderIDs: ids,
            });
            break;
          }
          case BrandSafetyRuleTargetingTypeBidderGroup: {
            this.setState({
              selectedBidderGroupIDs: ids,
            });
            break;
          }
          case BrandSafetyRuleTargetingTypeChannel: {
            this.setState({
              selectedChannelIDs: ids,
            });
            break;
          }
          case BrandSafetyRuleTargetingTypeChannelGroup: {
            this.setState({
              selectedChannelGroupIDs: ids,
            });
            break;
          }
          default:
            return;
        }
      };

      const options = getOptions();

      return (
        <Rows>
          <Row noPadding paddingBottom={spacing.small}>
            <Text large bold tKey='RuleTargeting' />
          </Row>

          <Row noPadding paddingBottom={spacing.large}>
            <Text small tKey='RuleTargetingDescription' />
          </Row>

          <Row noPadding paddingBottom={spacing.base}>
            <PillSwitcherV2
              size='base'
              options={BrandSafetyTargetingTypes.map(
                (type: number): ISimpleOptionSelect => ({
                  key: String(type),
                  value: String(type),
                  label: ct(BrandSafetyTargetingTypeToTKey[type]),
                  isSelected: RuleTargetingType === type,
                  isDisabled: false,
                }),
              )}
              onChange={(value: string) => {
                const ruleTargetingType = Number(value);
                this.setState({
                  reactKey: this.state.reactKey + 1, // force re-render
                  RuleTargetingType: ruleTargetingType,
                  ruleType:
                    ruleTargetingType !== BrandSafetyRuleTargetingTypeChannel &&
                    ruleTargetingType !== BrandSafetyRuleTargetingTypeChannelGroup &&
                    this.state.ruleType === RuleTypeLanguage
                      ? RuleTypeIAB
                      : this.state.ruleType, // language rule type is supported only for channel and channel group targeting
                  ...deselectOtherRuleTypeOptions(ruleTargetingType),
                });
              }}
            />
          </Row>

          <Row noPadding paddingBottom={spacing.base}>
            {getLoadingOptions() ? (
              <Skeleton
                variant='rect'
                animation='wave'
                width={320}
                height={28}
                style={{ borderRadius: borderRadius.base }}
              />
            ) : (
              <IndependentSelectV2
                displayID
                maxWidth={320}
                key={this.state.reactKey}
                selectKey={BrandSafetyTargetingTypeToTKey[RuleTargetingType]}
                labelTKey={BrandSafetyTargetingTypeToTKey[RuleTargetingType]}
                selectedLimit={options.length}
                handleApplySelect={(ids: Set<number>) =>
                  updateSelectedIDs(RuleTargetingType, [...ids])
                }
                options={options}
                selectedOptionIDs={new Set(getSelectedIDs())}
              />
            )}
          </Row>

          {/* Accordion*/}
          <Row noPadding>
            <MultiAccordion
              title={ct('TargetingParameters')}
              panels={multiAccordionPanels}
              disableEdit={!hasWriteCurrentRuleRight.isAuthorized}
            />
          </Row>
        </Rows>
      );
    };

    // ########## FUNCTIONS for Geo Panel ####################

    // determines if the current user can write and returns permissions
    getWriteCampaignAuthorization = (): IPermissionCheck => {
      return IS_AUTHORIZED(['write_campaign'], this.props.user.user);
    };

    // [LocalTargeting] addLocalTargetingParam handles adding a new local targeting param
    addLocalTargetingParam = (allowed: boolean): void => {
      if (allowed) {
        this.setState({
          localTargetingAllowedParameters: update(this.state.localTargetingAllowedParameters, {
            $push: [
              {
                type: 'country',
                country: '',
                states: '',
                cities: '',
                zips: '',
                dmas: '',
                isInputInCommaSeparatedMode: false,
              } as ILocalTargetingParameter,
            ],
          }) as ILocalTargetingParameter[],
        });
      } else {
        this.setState({
          localTargetingDisallowedParameters: update(
            this.state.localTargetingDisallowedParameters,
            {
              $push: [
                {
                  type: 'country',
                  country: '',
                  states: '',
                  cities: '',
                  zips: '',
                  dmas: '',
                  isInputInCommaSeparatedMode: false,
                } as ILocalTargetingParameter,
              ],
            },
          ) as ILocalTargetingParameter[],
        });
      }
    };

    // [LocalTargeting] updateLocalTargetingParam handles type or value change for local targeting params
    updateLocalTargetingParam = (allowed: boolean, index: number, updates: object): void => {
      if (allowed) {
        this.setState({
          localTargetingAllowedParameters: update(this.state.localTargetingAllowedParameters, {
            [index]: {
              $set: { ...this.state.localTargetingAllowedParameters[index], ...updates },
            },
          }) as ILocalTargetingParameter[],
        });
      } else {
        this.setState({
          localTargetingDisallowedParameters: update(
            this.state.localTargetingDisallowedParameters,
            {
              [index]: {
                $set: { ...this.state.localTargetingDisallowedParameters[index], ...updates },
              },
            },
          ) as ILocalTargetingParameter[],
        });
      }
    };

    // [LocalTargeting] deleteLocalTargetingParam handles deleting a local targeting param
    deleteLocalTargetingParam = (allowed: boolean, index: number): void => {
      if (allowed) {
        this.setState({
          localTargetingAllowedParameters: update(this.state.localTargetingAllowedParameters, {
            $splice: [[index, 1]],
          }) as ILocalTargetingParameter[],
        });
      } else {
        this.setState({
          localTargetingDisallowedParameters: update(
            this.state.localTargetingDisallowedParameters,
            {
              $splice: [[index, 1]],
            },
          ) as ILocalTargetingParameter[],
        });
      }
    };

    deleteCountryGroupFunc = (countryGroupID: string, reloadBidder: boolean): void => {
      const { publisherCountryGroups, targetingCountryGroupList } = this.state;
      const foundCountryGroup = publisherCountryGroups.find(
        (countryGroup: ICountryGroup) => countryGroup.ID.toString() === countryGroupID,
      );

      if (foundCountryGroup) {
        const clonedPublisherCountryGroups = cloneDeep(publisherCountryGroups);
        const filteredPublisherCountryGroups = clonedPublisherCountryGroups.filter(
          (countryGroup: ICountryGroup) => countryGroup.ID !== foundCountryGroup.ID,
        );

        const clonedTargetingCountryGroupList = cloneDeep(targetingCountryGroupList);
        delete clonedTargetingCountryGroupList[foundCountryGroup.ID];

        deleteCountryGroup(foundCountryGroup).then(() => {
          this.setState(
            {
              openRegionCreateEditDialog: false,
              openRegionSelectTable: false,
              publisherCountryGroups: filteredPublisherCountryGroups,
              targetingCountryGroupList: clonedTargetingCountryGroupList,
              updatingCountryGroup: false,
              snackbarMessage: ct('SnackbarSuccessfullyDeletedItem', { item: ct('CountryGroup') }),
              snackbarError: false,
            },
            reloadBidder ? this.getCountryGroupsByPublisherID : undefined,
          );
        });
      }
    };

    // [LocalTargeting] exportLocalTargetingParamToJSON exports all the local targeting params to a json string
    exportLocalTargetingParamToJSON = (allowed: boolean): string => {
      const params = allowed
        ? this.state.localTargetingAllowedParameters
        : this.state.localTargetingDisallowedParameters;
      const filteredList = exportLocalTargetingToJSON(params);
      return JSON.stringify(filteredList);
    };

    handleSetUpdatingCountryGroup = (updatingCountryGroup: boolean): void => {
      this.setState({ updatingCountryGroup });
    };

    handleOpenRegionSelectDialog = (countryGroupID: string): void => {
      const { publisherCountryGroups } = this.state;
      const foundCountryGroup = publisherCountryGroups.find(
        (countryGroup: ICountryGroup) => countryGroup.ID.toString() === countryGroupID,
      );

      let newCreateEditRegionList = generateCountriesMenuList();
      let newCreateEditRegionName = '';
      if (foundCountryGroup) {
        newCreateEditRegionList = generateCountryMenuListFromIsos(
          foundCountryGroup.CountryIsos.split(','),
        );
        newCreateEditRegionName = foundCountryGroup.Name;
      }
      this.setState({
        createEditRegionID: countryGroupID,
        createEditRegionList: newCreateEditRegionList,
        createEditRegionName: newCreateEditRegionName,
        openRegionCreateEditDialog: true,
        openRegionSelectTable: false,
      });
    };

    getCountryGroupsByPublisherID = (): void => {
      const { targetingCountryGroupList } = this.state;
      const { session } = this.props;

      getCountryGroupsByPublisherID(session.publisher.ID)
        .then((countryGroups: ICountryGroup[]) => {
          // create the updated menu list and update the state
          const updatedCountryGroupMenuList = generateNewTargetingCountryGroupList(
            targetingCountryGroupList,
            countryGroups,
          );
          this.setState({
            publisherCountryGroups: countryGroups,
            targetingCountryGroupList: updatedCountryGroupMenuList,
          });
        })
        .then(this.populateTargetingCountryGroupList);
    };

    getCommonRegionGroupsByIDs = (): void => {
      getCountryGroupsByIDs(commonRegionGroupsIDs, this.props.session.publisher.ID)
        .then((regionGroups) => {
          this.setState({ commonRegionGroups: regionGroups[0] });
        })
        .catch(() => {
          this.setState({
            commonRegionGroups: [],
            snackbarError: true,
            snackbarMessage: ct('ErrorLoadingItem', { item: ct('CountryGroup') }),
          });
        });
    };

    getCreativeValidationsAllowed = (): void => {
      this.setState(
        {
          loadingCreativeValidations: true,
        },
        () => {
          const query = {
            adomain_filter: this.state.TargetedAdomains,
            active_column_keys: [],
            category_filter: this.state.TargetedIABs,
            creative_url_filter: this.state.TargetedMediafiles,
            creative_id_filter: this.state.TargetedCreativeIDs,
            site_filter: '',
            bidder_filter: '',
            bidder_tier_filter: '',
            demand_source_filter: '',
            brand_safety_rule_ids: String(this.props.rule.ID),
            // fetch all the creatives and let the table decides the pagination
            // TODO: use API pagination instead
            no_limit: 'true',
            order_by: 0,
            page: 0,
            user_filter: '',
          };

          getCreativeValidationsV2(this.props.session.publisher.ID, REVIEW_STATUS_ALLOWED, query)
            .then((allowedCreativeValidations: ICreativeValidation[]) => {
              this.setState({
                allowedCreativeValidations,
                loadingCreativeValidations: false,
              });
            })
            .catch(() => {
              this.setState({
                allowedCreativeValidations: [],
                snackbarError: true,
                snackbarMessage: ct('ErrorLoadingItem', { item: ct('CreativeValidations') }),
                loadingCreativeValidations: false,
              });
            });
        },
      );
    };

    // populateTargetingCountryGroupList sets the selected value in targetingCountryGroupList
    // based on the TargetingCountryGroupIDs on the headerbidder, then updates the state
    populateTargetingCountryGroupList = (): void => {
      const { targetingCountryGroupList, TargetingCountryGroupIDs } = this.state;

      const clonedTargetingCountryGroupList = cloneDeep(targetingCountryGroupList);
      const selectedCountryGroupIDs = TargetingCountryGroupIDs.split(',');

      for (const selectedCountryGroupID of selectedCountryGroupIDs) {
        if (clonedTargetingCountryGroupList[selectedCountryGroupID] !== undefined) {
          clonedTargetingCountryGroupList[selectedCountryGroupID].selected = true;
        }
      }

      this.setState({
        targetingCountryGroupList: clonedTargetingCountryGroupList,
      });
    };

    populateTargetingCountriesList(): void {
      // Device local targeting countries setup
      // If number of selected countries < total/2, we are in Allow list mode
      const ckeys: string[] = this.state.TargetingDeviceCountry.split(',');
      if (ckeys.length < getAllCountries().length / 2) {
        // Allowlist mode
        for (let selectedCountry of ckeys) {
          selectedCountry = selectedCountry.toLowerCase();
          if (this.state.targetingCountriesList[selectedCountry] !== undefined) {
            this.state.targetingCountriesList[selectedCountry].selected = true;
          }
        }
        this.setState({
          targetingCountriesList: this.state.targetingCountriesList,
          deviceTargetingCountrySelectMode: SelectMode.Allowlist,
        });
      } else {
        // Denylist mode
        for (const key of Object.keys(this.state.targetingCountriesList)) {
          this.state.targetingCountriesList[key].selected = true;
        }

        for (let selectedCountry of ckeys) {
          selectedCountry = selectedCountry.toLowerCase();
          if (this.state.targetingCountriesList[selectedCountry] !== undefined) {
            this.state.targetingCountriesList[selectedCountry].selected = false;
          }
        }

        this.setState({
          targetingCountriesList: this.state.targetingCountriesList,
          deviceTargetingCountrySelectMode: SelectMode.Denylist,
        });
      }
    }

    renderAllRegionsDialog = (regionRow: IInputRow): ReactElement => {
      const { openRegionSelectTable, writeAuthorization } = this.state;

      const onCloseFn = (reloadCampaign: boolean, redirectToAllRegions?: boolean): void => {
        this.setState(
          {
            createEditRegionID: '',
            createEditRegionList: generateCountriesMenuList(),
            createEditRegionName: '',
            openRegionCreateEditDialog: false,
            openRegionSelectTable: !!redirectToAllRegions,
          },
          reloadCampaign ? this.getCountryGroupsByPublisherID : undefined,
        );
      };
      return (
        <Grid item style={{ width: '100%' }}>
          <InputRow rowInfo={regionRow} disableEdit={!writeAuthorization.isAuthorized} />
          {openRegionSelectTable ? (
            <Dialog
              fullWidth
              maxWidth='md'
              open={openRegionSelectTable}
              onClose={() => this.setState({ openRegionSelectTable: false })}
            >
              <Rows>
                <Row extraLargePadding>{this.renderRegionListTableDialog()}</Row>
                <Row extraLargePadding paddingTop='0' style={{ textAlign: 'right' }}>
                  <ButtonV2 clearBackground onClick={() => onCloseFn(false, false)}>
                    <Text tKey='Close' style={{ color: 'inherit', fontWeight: 'inherit' }} />
                  </ButtonV2>
                </Row>
              </Rows>
            </Dialog>
          ) : (
            this.renderCreateEditRegionDialog()
          )}
        </Grid>
      );
    };

    // Local Targeting Disallowed
    renderLocalTargetingAllowedPanel = (): ReactElement => {
      const writeAuthorization = this.getWriteCampaignAuthorization();
      return (
        <LocalTargeting
          isCloneOrBulkUpdate={false}
          localTargetingParameters={this.state.localTargetingAllowedParameters}
          LocalTargetingLogic={this.state.LocalTargetingAllowedLogic}
          localTargetingLogicFieldName='LocalTargetingAllowedLogic'
          LocalTargetingIsAllowed={this.state.LocalTargetingIsAllowed as boolean}
          addLocalTargetingParam={() => this.addLocalTargetingParam(true)}
          resourceName='Brand Safety Rule'
          disabled={!writeAuthorization.isAuthorized}
          handleChange={this.handleChange}
          updateLocalTargetingParam={(index: number, updates: object) =>
            this.updateLocalTargetingParam(true, index, updates)
          }
          deleteLocalTargetingParam={(index: number) => this.deleteLocalTargetingParam(true, index)}
          titleOverride={ct('LocalTargetingIncluded')}
        />
      );
    };

    // Local Targeting Allowed
    renderLocalTargetingDisallowedPanel = (): ReactElement => {
      const writeAuthorization = this.getWriteCampaignAuthorization();
      return (
        <LocalTargeting
          isCloneOrBulkUpdate={false}
          localTargetingParameters={this.state.localTargetingDisallowedParameters}
          LocalTargetingLogic={this.state.LocalTargetingDisallowedLogic}
          localTargetingLogicFieldName='LocalTargetingDisallowedLogic'
          LocalTargetingIsAllowed={this.state.LocalTargetingIsAllowed as boolean}
          addLocalTargetingParam={() => this.addLocalTargetingParam(false)}
          resourceName='Brand Safety Rule'
          disabled={!writeAuthorization.isAuthorized}
          handleChange={this.handleChange}
          updateLocalTargetingParam={(index: number, updates: object) =>
            this.updateLocalTargetingParam(false, index, updates)
          }
          deleteLocalTargetingParam={(index: number) =>
            this.deleteLocalTargetingParam(false, index)
          }
          titleOverride={ct('LocalTargetingExcluded')}
        />
      );
    };

    renderRegionListTableDialog = (): ReactElement => {
      const { user } = this.props;
      const { publisherCountryGroups, updatingCountryGroup } = this.state;

      const listTableColumns: IListTableColumn[] = [
        {
          field: 'Name',
          title: ct('RegionName'),
          renderType: 'modal3',
          searchable: true,
          maxWidth: '200px',
        },
        {
          field: 'CountriesTargeted',
          title: ct('CountriesTargeted'),
          renderType: 'normal',
          searchable: false,
          maxWidth: '100px',
        },
        { field: 'Actions', title: ct('Actions'), renderType: 'delete', searchable: false },
      ];

      const listTableData: ICountryGroupRowData[] = publisherCountryGroups.map(
        (countryGroup: ICountryGroup) => {
          const countryGroupName = checkUserInfoMasked(user.user)
            ? `demo_site_${countryGroup.ID}`
            : countryGroup.Name;
          return {
            ID: countryGroup.ID.toString(),
            Name: countryGroupName,
            CountriesTargeted:
              (countryGroup.CountryIsos && countryGroup.CountryIsos.split(',').length) || 0,
          };
        },
      );

      return (
        <ListTable
          title=''
          columns={listTableColumns}
          data={listTableData}
          isUpdating={updatingCountryGroup}
          handleSetUpdating={this.handleSetUpdatingCountryGroup}
          handleDeleteItem={(countryGroupID: string) =>
            this.deleteCountryGroupFunc(countryGroupID, true)
          }
          handleOpenModal3={this.handleOpenRegionSelectDialog}
          fixedEnabled={true}
          renderCustomToolbar={this.renderCustomToolbar}
          pageSize={10}
        />
      );
    };

    // renderCustomToolbar renders the toolbar at the top of the list table
    renderCustomToolbar = (props: {
      searchFieldStyle?: React.CSSProperties;
      [key: string]: unknown;
    }): ReactElement => {
      const { updatingCountryGroup } = this.state;

      const copyProps = {
        ...props,
        searchFieldStyle: { ...props.searchFieldStyle, marginLeft: '-48px', width: '300px' },
      };

      return (
        <Cols style={{ alignItems: 'center', justifyContent: 'space-between' }}>
          <Col>
            <MTableToolbar {...copyProps} />
          </Col>
          <Col>
            <ButtonV2
              disabled={updatingCountryGroup}
              onClick={() => {
                this.setState({
                  openRegionSelectTable: false,
                  openRegionCreateEditDialog: true,
                });
              }}
            >
              <Text
                tKey='PlusAddItem'
                tProps={{ item: ct('Region') }}
                style={{ color: 'inherit', fontWeight: 'inherit ' }}
              />
            </ButtonV2>
          </Col>
        </Cols>
      );
    };

    renderCreateEditRegionDialog = (): ReactElement | null => {
      const regionNametoTKey: Record<string, TKey> = {
        EMEA: 'EMEA',
        LATAM: 'LATAM',
        APAC: 'APAC',
        MENA: 'MENA',
        AFRICA: 'Africa',
        'North America': 'NorthAmerica',
      };

      const { session } = this.props;
      const {
        createEditRegionID,
        createEditRegionList,
        createEditRegionName,
        errors,
        openRegionCreateEditDialog,
        writeAuthorization,
        commonRegionGroups,
      } = this.state;

      const onCloseFn = (reloadCampaign: boolean, redirectToAllRegions?: boolean): void => {
        this.setState(
          {
            createEditRegionID: '',
            createEditRegionList: generateCountriesMenuList(),
            createEditRegionName: '',
            openRegionCreateEditDialog: false,
            openRegionSelectTable: !!redirectToAllRegions,
          },
          reloadCampaign ? this.getCountryGroupsByPublisherID : undefined,
        );
      };

      const newCountryIsos = Object.keys(createEditRegionList).filter(
        (key) => createEditRegionList[key].selected,
      );
      const newCountryGroup = {
        CountryIsos: newCountryIsos.map((countryIso) => countryIso.toUpperCase()).join(','),
        Name: createEditRegionName,
        PublisherID: parseInt(session.publisher.ID, 10),
      } as ICountryGroup;

      // clicking on pre-selectable common region selects all default countries in that region
      const onCommonRegionClick = (countryGroup: ICountryGroup): void => {
        this.setState({
          createEditRegionList: generateCountryMenuListFromIsos(
            countryGroup.CountryIsos.split(','),
          ),
          createEditRegionName: countryGroup.Name,
        });
      };

      return openRegionCreateEditDialog ? (
        <Dialog
          fullWidth
          maxWidth='sm'
          open={openRegionCreateEditDialog}
          onClose={() => onCloseFn(false, false)}
        >
          <Rows extraLargePadding>
            <Row noPadding paddingBottom={spacing.large}>
              <Text
                subheader
                tKey={!createEditRegionID ? 'CreateNewItem' : 'EditItem'}
                tProps={{ item: ct('Region') }}
              />
            </Row>

            <Row noPadding paddingBottom={spacing.small} paddingTop='0'>
              <Text extraSmall muted tKey='RegionName' />
            </Row>

            <Row noPadding paddingBottom={spacing.base} paddingTop='0'>
              <TextInput
                width='320px'
                placeholder={ct('RegionName')}
                inputSize='small'
                initialValue={createEditRegionName}
                handleOnChange={(input: string) => {
                  this.handleChange({
                    target: { name: 'createEditRegionName', value: input },
                  });
                }}
              />
            </Row>

            <Row noPadding paddingBottom={spacing.base} paddingTop='0'>
              {(commonRegionGroups || []).map((countryGroup: ICountryGroup) => {
                return (
                  <TextButton
                    key={countryGroup.ID}
                    color={
                      this.state.createEditRegionName === countryGroup.Name
                        ? publicaColors.blue
                        : publicaColors.gray
                    }
                    onClick={() => onCommonRegionClick(countryGroup)}
                    style={{ paddingRight: spacing.base }}
                  >
                    <Text
                      small
                      style={{ color: 'inherit', fontWeight: 'inherit' }}
                      tKey={regionNametoTKey[countryGroup.Name]}
                    />
                  </TextButton>
                );
              })}
            </Row>

            <Row noPadding paddingBottom={spacing.large} paddingTop='0' style={{ height: '520px' }}>
              <Text small muted tKey='SelectCountriesToIncludeInRegion' />
              {/* eslint-disable-next-line no-restricted-syntax */}
              <MaterialSearchDropdownMulti
                width='100%'
                placeholder={ct('SelectCountriesToIncludeInRegion')}
                forceOpen={true}
                fontSize={
                  isLanguageOversized(i18next.language) ? fontSizing.extraSmall : fontSizing.small
                }
                getValueFromSearchElement={(src: IListItem) => src.title}
                selectAll={true}
                menuTitle={ct('Country')}
                list={createEditRegionList}
                disabled={!writeAuthorization.isAuthorized}
                onChange={this.handleChangeList('createEditRegionList')}
                handleMenuAcceptClick={() => null}
                isNoneSelectedAllSelected={true}
                keepDropdownOpen={true}
              />
            </Row>

            <Row noPadding paddingTop='0' style={{ textAlign: 'right' }}>
              <ButtonV2
                onClick={() => {
                  const regionValidationErrors = validatorFactory(regionValidationSetting)(
                    this.state,
                  );
                  if (hasErrors(regionValidationErrors)) {
                    const errorText = Object.values(errors)
                      .filter((value) => value.length)
                      .join('. ');
                    this.setState(
                      {
                        errors: regionValidationErrors,
                        snackbarMessage: ct('SnackbarPleaseFixErrorsBeforeSavingItemWithReasons', {
                          item: ct('Region'),
                          text: errorText,
                        }),
                        snackbarError: true,
                      },
                      () => {
                        setTimeout(() => {
                          this.setState({
                            errors: {} as IErrors,
                          });
                          this.snackbarClose();
                        }, 6000);
                      },
                    );
                    return;
                  }

                  if (!createEditRegionID) {
                    createCountryGroup(newCountryGroup)
                      .then(() => {
                        this.setState({
                          snackbarError: false,
                          snackbarMessage: ct('SnackbarSuccessfullyCreatedItem', {
                            item: ct('Region'),
                          }),
                        });
                        onCloseFn(true, false);
                      })
                      .catch(() => {
                        this.setState({
                          snackbarError: true,
                          snackbarMessage: ct('SnackbarFailedToCreateItem', { item: ct('Region') }),
                        });
                      });
                  } else {
                    newCountryGroup.ID = parseInt(createEditRegionID, 10);
                    this.setState(
                      {
                        updatingCountryGroup: true,
                      },
                      () => {
                        updateCountryGroup(newCountryGroup)
                          .then(() => {
                            this.setState({
                              snackbarError: false,
                              snackbarMessage: ct('SnackbarSuccessfullyUpdatedItem', {
                                item: ct('Region'),
                              }),
                              updatingCountryGroup: false,
                            });
                            onCloseFn(true, false);
                          })
                          .catch(() => {
                            this.setState({
                              snackbarError: true,
                              snackbarMessage: ct('SnackbarFailedToUpdateItem', {
                                item: ct('Region'),
                              }),
                            });
                          });
                      },
                    );
                  }
                }}
              >
                <Text tKey='Save' style={{ color: 'inherit', fontWeight: 'inherit' }} />
              </ButtonV2>

              <ButtonV2
                clearBackground
                onClick={() => onCloseFn(false, true)}
                style={{ marginLeft: spacing.small }}
              >
                <Text tKey='Close' style={{ color: 'inherit', fontWeight: 'inherit' }} />
              </ButtonV2>
            </Row>
          </Rows>
        </Dialog>
      ) : null;
    };

    // ############################## RENDER TOP BAR WITH RULE NAME AND ACTIVE SWITCH ##############################
    renderTopBar(): React.ReactNode {
      const canEditRule = this.state.hasWriteCurrentRuleRight.isAuthorized;

      return (
        <div>
          <ElevationScroll {...this.props}>
            <AppBar
              position='relative'
              elevation={0}
              style={{
                backgroundColor: '#F8faff',
              }}
            >
              <Toolbar style={{ width: '100%' }}>
                <Cols
                  style={{ width: '100%', alignItems: 'center', justifyContent: 'space-between' }}
                >
                  <Col>
                    <ModernTextField
                      disabled={!canEditRule}
                      value={
                        checkUserInfoMasked(this.props.user.user)
                          ? 'demo_rule_' + this.state.ID
                          : this.state.Name
                      }
                      onChange={({ target }: React.ChangeEvent<HTMLInputElement>) => {
                        this.setState({
                          Name: target.value,
                        });
                      }}
                    />
                  </Col>

                  <Col>
                    <Cols gap={spacing.small} style={{ alignItems: 'center' }}>
                      <Col>
                        <Text
                          small
                          tKey={
                            this.state.Active === BrandSafetyRuleActiveActive
                              ? 'Active'
                              : 'Inactive'
                          }
                        />
                      </Col>

                      <Col>
                        <Switch
                          disabled={!canEditRule}
                          checked={this.state.Active === BrandSafetyRuleActiveActive}
                          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            this.setState({
                              Active: event.target.checked
                                ? BrandSafetyRuleActiveActive
                                : BrandSafetyRuleActiveInactive,
                            });
                          }}
                        />
                      </Col>

                      <Col>
                        <ButtonV2 disabled={!canEditRule} onClick={() => this.saveRule()}>
                          <Text
                            small
                            tKey='Save'
                            style={{ color: 'inherit', fontWeight: 'inherit' }}
                          />
                        </ButtonV2>
                      </Col>

                      <Col>
                        <ButtonV2
                          clearBackground
                          disabled={!canEditRule}
                          onClick={() => this.handleCloseButtonClick()}
                        >
                          <Text
                            small
                            tKey='Close'
                            style={{ color: 'inherit', fontWeight: 'inherit' }}
                          />
                        </ButtonV2>
                      </Col>
                    </Cols>
                  </Col>
                </Cols>
              </Toolbar>
            </AppBar>
          </ElevationScroll>
        </div>
      );
    }

    // ############################## RENDER RULE TARGETING TAB ##############################
    renderRuleTargetingTab = (): React.ReactNode => {
      const isSuperUser = hasRoleSuperUser(this.props.user.user);
      const isDisabled = !this.state.hasWriteCurrentRuleRight.isAuthorized;
      const { ruleType, RuleTargetingType } = this.state;

      return (
        <Rows largeVerticalPadding extraLargeHorizontalPadding>
          <Row
            hugeHorizontalPadding
            largeVerticalPadding
            marginBottom={spacing.base}
            style={{
              borderRadius: borderRadius.large,
              border: `1px solid ${publicaColors.lightGray}`,
              backgroundColor: publicaColors.white,
            }}
          >
            {this.renderBrandSafetyRuleTargeting()}
          </Row>

          <Row
            hugeHorizontalPadding
            largeVerticalPadding
            style={{
              borderRadius: borderRadius.large,
              border: `1px solid ${publicaColors.lightGray}`,
              backgroundColor: publicaColors.white,
            }}
          >
            <Cols paddingBottom={spacing.small} style={{ alignItems: 'center' }}>
              <Col>
                <Text large bold tKey='RuleType' />
              </Col>
              {!this.state.hasWriteCurrentRuleRight.isAuthorized && (
                <Col marginLeft={spacing.small}>
                  <Text extraSmall muted tKey='ReadOnly' />
                </Col>
              )}
            </Cols>

            <Div style={{ marginBottom: spacing.large }}>
              <Text small tKey='RuleTypeDescription' />
            </Div>

            <Div style={{ marginBottom: spacing.base }}>
              <PillSwitcherV2
                isDisabled={isDisabled}
                size='base'
                options={getBrandSafetyTypeOptions(
                  RuleTargetingType === BrandSafetyRuleTargetingTypeChannel ||
                    RuleTargetingType === BrandSafetyRuleTargetingTypeChannelGroup,
                ).map(
                  (type: number): ISimpleOptionSelect => ({
                    key: String(type),
                    value: String(type),
                    label: ct(BrandSafetyTypeToTKey[type]),
                    isSelected: ruleType === type,
                    isDisabled: false,
                  }),
                )}
                onChange={(value: string) => {
                  this.setState({
                    ruleType: Number(value),
                  });
                }}
              />
            </Div>

            {/* RULE TYPE CONFIG*/}
            {this.state.ruleType === RuleTypeIAB &&
              this.renderRuleTypeIABEntry(RuleTargetingTab, isDisabled, undefined)}
            {this.state.ruleType === RuleTypeAdomain &&
              this.renderRuleTypeAdomainEntry(
                RuleTargetingTab,
                false,
                isDisabled,
                this.state.TargetingAdomainExceptionState,
                undefined,
              )}
            {this.state.ruleType === RuleTypeMediafile &&
              this.renderRuleTypeMediafileEntry(RuleTargetingTab, isDisabled)}
            {this.state.ruleType === RuleTypeLanguage &&
              this.renderRuleTypeLanguageEntry(RuleTargetingTab, isDisabled)}
            {this.state.ruleType === RuleTypeCreativeID &&
              this.renderRuleTypeCreativeIDEntry(RuleTargetingTab, isDisabled)}
            {this.state.ruleType === RuleTypeEventTracker &&
              this.renderRuleTypeEventTrackerEntry(RuleTargetingTab, isDisabled)}

            {this.renderRuleTargetedExceptionDialog()}

            {isSuperUser && <Text small bold tKey='Options' style={{ marginTop: spacing.large }} />}

            <Cols paddingLeft={spacing.small} style={{ alignItems: 'center' }}>
              <Col>
                <Switch
                  name='EnableSaveCreativeValidations'
                  disabled={isDisabled}
                  checked={this.state.EnableSaveCreativeValidations === EBool.EBool_TRUE}
                  onChange={this.handleChange}
                />
              </Col>
              <Col marginLeft={spacing.small}>
                <Text small tKey='ReviewBlockedCreatives' />
              </Col>
              <Col marginLeft={spacing.extraSmall}>
                <TooltipWithTranslation tKey='BrandSafetyTooltipReviewBlockedCreatives'>
                  <div>
                    <IconV2 small name='info' color={publicaColors.mediumGray} />
                  </div>
                </TooltipWithTranslation>
              </Col>
            </Cols>

            <Cols paddingLeft={spacing.small} style={{ alignItems: 'center' }}>
              <Col>
                <Switch
                  name='EnableBlockBidsWithEmptyIABCatAdomain'
                  disabled={isDisabled}
                  checked={this.state.EnableBlockBidsWithEmptyIABCatAdomain === EBool.EBool_TRUE}
                  onChange={this.handleChange}
                />
              </Col>
              <Col marginLeft={spacing.small}>
                <Text small tKey='BlockBidsWithMissingValues' />
              </Col>
              <Col marginLeft={spacing.extraSmall}>
                <TooltipWithTranslation tKey='BrandSafetyTooltipBlockBidsWithMissingValues'>
                  <div>
                    <IconV2 small name='info' color={publicaColors.mediumGray} />
                  </div>
                </TooltipWithTranslation>
              </Col>
            </Cols>
          </Row>
        </Rows>
      );
    };

    handleDaypartingDateChange = (index: number, time: string, dateType: 'start' | 'end'): void => {
      if (!time) {
        return;
      }

      const DaypartingIntervals = handleDaypartingDateChange(
        index,
        time,
        dateType,
        this.state.DaypartingIntervals,
      );
      this.setState({
        DaypartingIntervals,
      });
    };

    handleDayClick = (day: Day, index: number): void => {
      const DaypartingIntervals = handleDaypartingDayClick(
        day,
        index,
        this.state.DaypartingIntervals,
      );
      this.setState({ DaypartingIntervals });
    };

    handleDeleteDaypartingPeriod = (index: number): void => {
      const DaypartingIntervals = handleDeleteDaypartingPeriod(
        index,
        this.state.DaypartingIntervals,
      );
      this.setState({ DaypartingIntervals });
    };

    handleAddDaypartingPeriod = (): void => {
      const DaypartingIntervals = handleAddDaypartingPeriod(this.state.DaypartingIntervals);
      this.setState({ DaypartingIntervals });
    };

    parseDayparting = (): void => {
      const daypartingObj = parseDayparting(this.state.Dayparting);

      const isDaypartingActive = daypartingObj[0];
      const DaypartingIntervals = daypartingObj[1];
      const enableViewerTimezone = daypartingObj[2] || false;
      this.setState({
        isDaypartingActive,
        DaypartingIntervals,
        enableViewerTimezone,
      });
    };

    getTimezoneList = (): void => {
      const { Timezone } = this.state;

      const timezonesList = genTimezoneList(Timezone || this.props.session.publisher.Timezone);

      // Convert IMenuList to ISelectOption[] for IndependentSelect
      const timezoneOptions: ISelectOption[] = Object.values(timezonesList).map(
        (item: IListItem) => ({
          id: item.ID,
          label: item.title,
        }),
      );

      this.setState({
        timezoneOptions,
      });
    };

    handleTimezoneSelect = (selectedIDs: Set<string | number>): void => {
      const selectedTimezone = Array.from(selectedIDs)[0];
      if (selectedTimezone) {
        const selectedOption = this.state.timezoneOptions.find(
          (option) => option.id === selectedTimezone,
        );
        if (selectedOption) {
          this.setState({
            Timezone: selectedOption.label,
          });
        }
      }
    };

    renderDayparting = (): React.ReactNode => {
      const {
        DaypartingIntervals,
        DaypartingIsAllowed,
        enableViewerTimezone,
        isDaypartingActive,
        reactKey,
      } = this.state;

      const writeAuthorization = IS_AUTHORIZED(['write_bidder'], this.props.user.user);

      const { classes } = this.props;

      return (
        <Grid style={{ width: '100%' }}>
          <Cols extraSmallVerticalPadding style={{ alignItems: 'center' }}>
            <Col style={{ minWidth: '35%' }}>
              <Cols style={{ alignItems: 'center' }}>
                <Col>
                  <Text small tKey={isDaypartingActive ? 'Active' : 'Inactive'} />
                </Col>
                <Col marginLeft={spacing.extraSmall}>
                  <TooltipWithTranslation tKey='BrandSafetyTooltipDayparting'>
                    <div>
                      <IconV2 small name='info' color={publicaColors.mediumGray} />
                    </div>
                  </TooltipWithTranslation>
                </Col>
              </Cols>
            </Col>

            <Col>
              <Switch
                checked={isDaypartingActive}
                name='DaypartingActive'
                onChange={this.handleChange}
                value={isDaypartingActive}
                color='secondary'
              />
            </Col>
          </Cols>

          {isDaypartingActive && (
            <>
              <Cols style={{ alignItems: 'center' }}>
                <Col style={{ minWidth: '36%' }}>
                  <Text small tKey='Logic' />
                </Col>
                <Col>
                  <Cols style={{ alignItems: 'center' }}>
                    <Col>
                      <Text
                        small
                        bold
                        tKey={DaypartingIsAllowed === EAllowStatus.ALLOW ? 'Include' : 'Exclude'}
                      />
                    </Col>
                    <Col gap={spacing.extraSmall}>
                      <ConfirmationDialogButton
                        title={ct('DaypartingIncludeExclude')}
                        description={makeTargetingChangeDescription(
                          DaypartingIsAllowed === EAllowStatus.ALLOW,
                        )}
                        triggerComponentInfo={makeTargetingChangeInfoHover(
                          DaypartingIsAllowed === EAllowStatus.ALLOW,
                        )}
                        acceptButtonTitle={ct('Confirm')}
                        acceptButtonCallBack={() =>
                          this.handleChange({
                            target: {
                              name: 'DaypartingIsAllowed',
                              value:
                                DaypartingIsAllowed === EAllowStatus.ALLOW
                                  ? EAllowStatus.DENY
                                  : EAllowStatus.ALLOW,
                            },
                          })
                        }
                        disabled={!writeAuthorization.isAuthorized}
                        refuseButtonTitle={ct('Cancel')}
                      >
                        <IconButton>
                          {DaypartingIsAllowed === EAllowStatus.ALLOW ? (
                            <IconV2 name='checkmark-plain' large color={publicaColors.green} />
                          ) : (
                            <IconV2 name='unavailable' large color={publicaColors.red} />
                          )}
                        </IconButton>
                      </ConfirmationDialogButton>
                    </Col>
                    <Col>
                      <Text
                        extraSmall
                        muted
                        tKey={
                          DaypartingIsAllowed === EAllowStatus.ALLOW
                            ? 'BrandSafetyTooltipDaypartingInclude'
                            : 'BrandSafetyTooltipDaypartingExclude'
                        }
                      />
                    </Col>
                  </Cols>
                </Col>
              </Cols>

              <Div
                style={{
                  padding: `${spacing.extraSmall} 0 ${spacing.base} 0`,
                }}
              >
                <Cols paddingBottom={spacing.extraSmall} style={{ alignItems: 'center' }}>
                  <Col style={{ minWidth: '36%' }}>
                    <Text small tKey='Timezone' />
                  </Col>
                  <Col>
                    <Cols wrap gap={spacing.base} style={{ alignItems: 'center' }}>
                      <Col>
                        <PillSwitcherV2
                          size='baseLong'
                          options={Object.entries(daypartingTimezonesToTKey)
                            .filter(([daypartingKey, _]: [string, TKey]) => {
                              return (
                                Number(daypartingKey) === Number(EDaypartingTimezonesType.Viewer) ||
                                Number(daypartingKey) ===
                                  Number(EDaypartingTimezonesType.BrandSafetyRule)
                              );
                            })
                            .map(([daypartingKey, value]: [string, TKey]): ISimpleOptionSelect => {
                              const isViewerTimezoneKey =
                                Number(daypartingKey) === Number(EDaypartingTimezonesType.Viewer);
                              const isRuleTimezoneKey =
                                Number(daypartingKey) ===
                                Number(EDaypartingTimezonesType.BrandSafetyRule);

                              return {
                                key: daypartingKey,
                                value: daypartingKey,
                                label: ct(value),
                                icon: isViewerTimezoneKey ? 'eye' : 'globe',
                                isSelected:
                                  (enableViewerTimezone && isViewerTimezoneKey) ||
                                  (!enableViewerTimezone && isRuleTimezoneKey),
                                isDisabled: false,
                              };
                            })}
                          onChange={(value: string) => {
                            const enableViewerTimezone =
                              Number(value) === Number(EDaypartingTimezonesType.Viewer);
                            this.setState({
                              enableViewerTimezone,
                            });
                          }}
                        />
                      </Col>
                      <Col>
                        <Text
                          extraSmall
                          muted
                          tKey={
                            enableViewerTimezone
                              ? 'DaypartingTimezoneDeviceLocationDescription'
                              : 'DaypartingTimezoneBrandSafetyRuleDescription'
                          }
                        />
                      </Col>
                    </Cols>
                  </Col>
                </Cols>

                {/* Timezone Dropdown - Only show when Rule Timezone is selected */}
                {!enableViewerTimezone && (
                  <Div
                    style={{
                      marginLeft: '36%',
                      padding: `${spacing.extraSmall} 0 0 0`,
                    }}
                  >
                    <IndependentSelectV2
                      key={reactKey}
                      selectKey='Timezone'
                      labelTKey='Timezone'
                      disableSearch
                      options={this.state.timezoneOptions}
                      selectedOptionIDs={
                        new Set(
                          this.state.timezoneOptions
                            .filter((option) => option.label === this.state.Timezone)
                            .map((option) => option.id),
                        )
                      }
                      selectedLimit={1}
                      isSelectionRequired={true}
                      handleApplySelect={this.handleTimezoneSelect}
                      maxWidth={240}
                      minWidth={240}
                    />
                  </Div>
                )}
              </Div>

              <Cols extraSmallVerticalPadding>
                <Col style={{ minWidth: '36%' }}>
                  <Text small tKey='Period' />
                </Col>
                <Col>
                  <DaypartingSelector
                    DaypartingIntervals={DaypartingIntervals}
                    handleDateChange={this.handleDaypartingDateChange}
                    handleDayClick={this.handleDayClick}
                    handleDeleteDaypartingPeriod={this.handleDeleteDaypartingPeriod}
                    handleAddDaypartingPeriod={this.handleAddDaypartingPeriod}
                    classes={classes}
                  />
                </Col>
              </Cols>
            </>
          )}
        </Grid>
      );
    };

    createException = (): void => {
      this.setState(
        {
          BrandSafetyRuleExceptions: update(this.state.BrandSafetyRuleExceptions, {
            $push: [
              {
                ID: 0,
                Name: `${ct('RuleExceptionName')} - ${new Date().getTime()}`,
                BidderIDs: '',
                AllowedAdomains: '',
                AllowedIABCategories: '',
                TargetedIABExceptions: '',
              },
            ],
          }) as IBrandSafetyRuleException[],
        },
        () => {
          this.handleOpenEditRuleExceptionDialog(
            undefined,
            this.state.BrandSafetyRuleExceptions.length - 1,
          );
        },
      );
    };

    deleteException = (_: unknown, idx: number): Promise<void> => {
      this.setState({
        BrandSafetyRuleExceptions: update(this.state.BrandSafetyRuleExceptions, {
          $splice: [[idx, 1]],
        }) as IBrandSafetyRuleException[],
        selectedRowIdx: undefined, // reset selected row index since it is deleted
      });

      return new Promise((resolve) => {
        resolve();
      });
    };

    handleOpenBidderSelectDialog = (_: unknown, idx: number): void => {
      this.setState({
        openBidderSelectTable: true,
        selectedRowIdx: idx,
      });
    };

    getTargetChannelIDs = (): string[] => {
      const targetChannels: { [key: number]: boolean } = {};
      const { channelGroups, RuleTargetingType } = this.state;
      const targetedObjects = this.createTargetedObjectsTable();

      if (RuleTargetingType === BrandSafetyRuleTargetingTypeChannel) {
        targetedObjects.forEach((t: IBrandSafetyRuleAssociationTable) => {
          targetChannels[t.TargetID] = true;
        });
      } else if (RuleTargetingType === BrandSafetyRuleTargetingTypeChannelGroup) {
        for (const targetedObject of targetedObjects) {
          for (const channelGroup of channelGroups as IChannelGroup[]) {
            if (targetedObject.TargetID === channelGroup.ID) {
              for (const channelIDSt of channelGroup.ChannelIDs.split(',')) {
                const channelID = parseInt(channelIDSt, 10);
                if (!isNaN(channelID)) {
                  targetChannels[channelID] = true;
                }
              }
            }
          }
        }
      }

      return Object.keys(targetChannels);
    };

    handleOpenRuleTargetedExceptionDialog = (targetedExceptionIABCode: string): void => {
      this.setState({
        openRuleTargetedExceptionDialog: true,
        openRuleTargetedExceptionDialogIABCode: targetedExceptionIABCode,
      });
    };

    handleOpenEditRuleExceptionDialog = (_: unknown, idx: number): void => {
      const exception = this.state.BrandSafetyRuleExceptions[idx];

      this.setState(
        {
          openEditRuleException: true,
          selectedRowIdx: idx,
          userEntryIABPrefixAllowed: '',
          userEntryIABSuffixAllowed: '',
          userEntryIABListAllowed: '',
          adomainUserEntryAllowed: '',
          adomainAllowed:
            exception.AllowedAdomains === ''
              ? ([] as string[])
              : exception.AllowedAdomains.split(','),
          iabListAllowed:
            exception.AllowedIABCategories === ''
              ? ([] as IIABCategoryTableItems[])
              : this.getIABListAllowed(exception.AllowedIABCategories),
        },
        () => {
          this.setState({
            bidderListAllowed: this.generateBidderListAllowed(),
          });
        },
      );
    };

    handleChange = ({ target }: React.ChangeEvent<HTMLInputElement>): void => {
      if (target.name === 'EnableSaveCreativeValidations') {
        this.setState({
          EnableSaveCreativeValidations:
            this.state.EnableSaveCreativeValidations === EBool.EBool_TRUE
              ? EBool.EBool_FALSE
              : EBool.EBool_TRUE,
        });
      } else if (target.name === 'EnableBlockBidsWithEmptyIABCatAdomain') {
        this.setState({
          EnableBlockBidsWithEmptyIABCatAdomain:
            this.state.EnableBlockBidsWithEmptyIABCatAdomain === EBool.EBool_TRUE
              ? EBool.EBool_FALSE
              : EBool.EBool_TRUE,
        });
      } else if (target.name === 'DaypartingActive') {
        this.setState(
          {
            isDaypartingActive: !this.state.isDaypartingActive,
          },
          () => {
            if (this.state.DaypartingIntervals.length === 0) {
              this.handleAddDaypartingPeriod();
            }
          },
        );
        return;
      } else {
        this.setState({
          [target.name]: target.value,
        });
      }
    };

    // ############################## RENDER RULE EXCEPTIONS LIST #############################
    renderRuleExceptionsList = (): ReactElement => {
      // define the brand safety rule exception table columns
      const listTableColumns: IListTableColumn[] = [
        {
          field: 'Name',
          title: ct('Name'),
          renderType: 'modal',
          searchable: true,
          textAlign: 'left',
          textAlignHeader: 'left',
        },
        {
          field: 'BidderIDs',
          title: ct('BidderIDs'),
          renderType: 'modal2',
          searchable: false,
          textAlign: 'left',
          textAlignHeader: 'left',
          cellStyle: {
            maxWidth: '160px',
          },
        },
        {
          field: 'AllowedAdomains',
          title: ct('AllowedItem', { item: ct('Adomains') }),
          renderType: 'normal',
          searchable: false,
          textAlign: 'left',
          textAlignHeader: 'left',
          cellStyle: {
            wordBreak: 'break-word',
          },
        },
        {
          field: 'AllowedIABCategories',
          title: ct('AllowedItem', { item: ct('IABCategories') }),
          renderType: 'normal',
          searchable: false,
          textAlign: 'left',
          textAlignHeader: 'left',
          cellStyle: {
            wordBreak: 'break-word',
          },
        },
        {
          field: 'Actions',
          title: ct('Actions'),
          renderType: 'delete',
          searchable: false,
          maxWidth: '120px',
        },
      ];

      const filteredListTableColumns = listTableColumns.filter((col: IListTableColumn) => {
        return (
          (this.state.ruleType === RuleTypeIAB && col.field !== 'AllowedIABCategories') ||
          (this.state.ruleType === RuleTypeAdomain && col.field !== 'AllowedAdomains')
        );
      });

      const exceptionData = this.state.BrandSafetyRuleExceptions.map(
        (exception: IBrandSafetyRuleException): IBrandSafetyRuleExceptionRowData => ({
          ID: exception.ID,
          Name: exception.Name,
          BidderIDs: exception.BidderIDs === '' ? 0 : exception.BidderIDs.split(',').length,
          AllowedIABCategories: exception.AllowedIABCategories,
          AllowedAdomains:
            exception.AllowedAdomainsState === BrandSafetyRuleTargetingAdomainExceptionStateAllowAll
              ? ct('AllItems', { item: ct('Adomains') })
              : exception.AllowedAdomains,
        }),
      );

      return (
        <ListTable
          isLoading={this.state.loadingBidderOptions}
          title={ct('AllowList')}
          columns={filteredListTableColumns}
          data={exceptionData}
          handleOpenModal={this.handleOpenEditRuleExceptionDialog}
          handleOpenModal2={this.handleOpenBidderSelectDialog}
          handleSetUpdating={noopVoid}
          handleDeleteItem={this.deleteException}
        />
      );
    };

    // ############################## RENDER RULE EXCEPTIONS TAB ##############################
    renderRuleExceptionsTab = (): React.ReactNode => {
      const {
        selectedRowIdx,
        BrandSafetyRuleExceptions,
        hasWriteCurrentRuleRight,
        loadingBidderOptions,
      } = this.state;

      return (
        <Rows largeVerticalPadding extraLargeHorizontalPadding>
          <Row paddingBottom={spacing.base} style={{ textAlign: 'right' }}>
            <ButtonV2
              disabled={!hasWriteCurrentRuleRight.isAuthorized || loadingBidderOptions}
              onClick={() => this.createException()}
            >
              <Text
                tKey='CreateNewItem'
                tProps={{ item: ct('Exception') }}
                style={{ color: 'inherit', fontWeight: 'inherit' }}
              />
            </ButtonV2>
            {loadingBidderOptions && (
              <Cols
                marginTop={spacing.extraSmall}
                gap={spacing.small}
                style={{ alignItems: 'center', justifyContent: 'end' }}
              >
                <Col>
                  <Text tKey='LoadingItemSettings' tProps={{ item: ct('Bidders') }} small muted />
                </Col>
                <Col>
                  <CircularProgress size={14} />
                </Col>
              </Cols>
            )}
          </Row>

          <Row>{this.renderRuleExceptionsList()}</Row>

          {this.renderRuleExceptionEditor()}
          {this.renderBidderSelector()}

          {selectedRowIdx !== undefined && BrandSafetyRuleExceptions[selectedRowIdx] && <></>}
        </Rows>
      );
    };

    renderRuleTargetedExceptionDialog(): ReactElement {
      const { openRuleTargetedExceptionDialog } = this.state;
      return (
        <Dialog
          fullWidth
          maxWidth='sm'
          onClose={() =>
            this.setState({
              openRuleTargetedExceptionDialog: false,
              openRuleTargetedExceptionDialogIABCode: '',
            })
          }
          open={openRuleTargetedExceptionDialog}
        >
          {/* TABLE WITH LIST OF ADDED ADOMAIN*/}
          <Grid container direction='row' justify='center' alignItems='center'>
            <Grid
              item
              style={{ height: '500px', width: '500px', maxHeight: '500px', margin: '20px' }}
            >
              {this.renderAdomainExceptionTable()}
            </Grid>
          </Grid>
        </Dialog>
      );
    }

    initializeMenuListFromTargetedIABs(): IMenuList {
      const { TargetedIABs } = this.state;
      const splitAllTargetedIABs = TargetedIABs.split(',');
      const iabMenuList = {} as IMenuList;
      for (const targetedIAB of splitAllTargetedIABs) {
        iabMenuList[targetedIAB] = {
          title: targetedIAB,
          selected: false,
          ID: targetedIAB,
        } as IListItem;
      }
      return iabMenuList;
    }

    generateMenuListFromBrandSafetyRuleException(
      brandSafetyRuleException: IBrandSafetyRuleException,
    ): IMenuList {
      const { TargetedIABs } = this.state;
      const splitAllTargetedIABs = TargetedIABs.split(',').filter(
        (targetedIAB) => targetedIAB !== '',
      );
      const iabMenuList = {} as IMenuList;
      for (const targetedIAB of splitAllTargetedIABs) {
        iabMenuList[targetedIAB] = {
          title: this.IABCategoryCodeToNameWithTranslation(targetedIAB),
          selected: false,
          ID: targetedIAB,
        } as IListItem;
      }

      if (brandSafetyRuleException === undefined) {
        return iabMenuList;
      }
      const splitSelectedTargetedIABs = brandSafetyRuleException.TargetedIABExceptions.split(',');
      const filteredSelectedTargetedIABs = splitSelectedTargetedIABs.filter(
        (targetedIAB) => targetedIAB !== '',
      );
      for (const selectedTargetedIAB of filteredSelectedTargetedIABs) {
        iabMenuList[selectedTargetedIAB].selected = true;
      }

      return iabMenuList;
    }

    renderRuleExceptionEditor(): ReactElement {
      const {
        bidderListAllowed,
        BrandSafetyRuleExceptions,
        openEditRuleException,
        selectedRowIdx,
        ruleType,
      } = this.state;
      const disabled = !this.state.hasWriteCurrentRuleRight.isAuthorized;

      let brandSafetyRuleException = {
        ID: 0,
        CreatedAt: '',
        UpdatedAt: '',
        DeletedAt: '',

        Name: '',
        BidderIDs: '',
        AllowedAdomains: '',
        AllowedIABCategories: '',
        TargetedIABExceptions: '',
      } as IBrandSafetyRuleException;

      if (selectedRowIdx !== undefined && BrandSafetyRuleExceptions[selectedRowIdx] !== undefined) {
        brandSafetyRuleException = BrandSafetyRuleExceptions[selectedRowIdx];
      }

      const brandSafetyRuleExceptionMenuList =
        this.generateMenuListFromBrandSafetyRuleException(brandSafetyRuleException);

      const isAdomainRuleException = ruleType === RuleTypeAdomain;
      const isIABCategoryRuleException = ruleType === RuleTypeIAB;

      return (
        <Dialog
          maxWidth='md'
          open={openEditRuleException as boolean}
          onClose={() => this.setState({ openEditRuleException: false })}
        >
          <Rows
            extraLargeVerticalPadding
            largeHorizontalPadding
            style={{ minHeight: '640px' }} // need to accommodate bidder selector dropdown
          >
            <Row noVerticalPadding marginBottom={spacing.base}>
              <Text
                tKey='RuleExceptionName'
                muted
                extraSmall
                style={{ marginBottom: spacing.extraSmall }}
              />
              <TextInput
                width='480px'
                placeholderTKey='RuleExceptionName'
                inputSize='small'
                initialValue={brandSafetyRuleException.Name}
                handleOnChange={(input: string) => {
                  if (selectedRowIdx !== undefined) {
                    const newExceptions = cloneDeep(this.state.BrandSafetyRuleExceptions);
                    newExceptions[selectedRowIdx].Name = input;
                    this.setState({
                      BrandSafetyRuleExceptions: newExceptions,
                    });
                  }
                }}
              />
            </Row>

            {/* bidder selector */}
            <Row noVerticalPadding>
              <Text tKey='Bidders' muted extraSmall style={{ marginBottom: spacing.extraSmall }} />
              {this.state.loadingBidderOptions ? (
                <Skeleton
                  variant='rect'
                  animation='wave'
                  width={320}
                  height={28}
                  style={{ borderRadius: borderRadius.base }}
                />
              ) : (
                <MaterialSearchDropdownMulti
                  getValueFromSearchElement={(src: IListItem) => src.title}
                  selectAll={true}
                  menuTitle={ct('Bidders')}
                  list={bidderListAllowed as IMenuList}
                  onChange={(updatedBidderList: IMenuList) => {
                    this.setState({
                      bidderListAllowed: updatedBidderList,
                    });
                  }}
                  handleMenuAcceptClick={(list: IMenuList) => {
                    if (selectedRowIdx !== undefined) {
                      const newExceptions = cloneDeep(this.state.BrandSafetyRuleExceptions);
                      const selectedBidderIDs = [];
                      for (const key in list) {
                        if (list[key].selected) {
                          selectedBidderIDs.push(list[key].ID);
                        }
                      }
                      newExceptions[selectedRowIdx].BidderIDs = selectedBidderIDs.join(',');
                      this.setState({
                        BrandSafetyRuleExceptions: newExceptions,
                        bidderListAllowed: list, // Update the bidder list state as well
                      });
                    }
                  }}
                  showPrefixID
                />
              )}
            </Row>

            {isIABCategoryRuleException && (
              <>
                <Row noVerticalPadding marginTop={spacing.base}>
                  <Text
                    tKey='IABCategories'
                    muted
                    extraSmall
                    style={{ marginBottom: spacing.extraSmall }}
                  />
                  {/* eslint-disable-next-line no-restricted-syntax */}
                  <MaterialSearchDropdownMulti
                    getValueFromSearchElement={(src: IListItem) => src.title}
                    selectAll={true}
                    menuTitle={ct('IABCategories')}
                    list={brandSafetyRuleExceptionMenuList}
                    showPrefixID
                    onChange={(list: IMenuList) => {
                      if (selectedRowIdx !== undefined) {
                        const selectedTargetedIABs = [];
                        for (const key in list) {
                          if (list[key].selected) {
                            selectedTargetedIABs.push(list[key].ID);
                          }
                        }
                        BrandSafetyRuleExceptions[selectedRowIdx].TargetedIABExceptions =
                          selectedTargetedIABs.join(',');
                        this.setState({
                          BrandSafetyRuleExceptions,
                        });
                      }
                    }}
                  />
                </Row>

                <Row noVerticalPadding marginBottom={spacing.base} marginTop={spacing.extraLarge}>
                  {this.renderRuleTypeAdomainEntry(
                    RuleExceptionTab,
                    true,
                    disabled,
                    brandSafetyRuleException.AllowedAdomainsState,
                    selectedRowIdx,
                  )}
                </Row>
              </>
            )}

            {isAdomainRuleException && (
              <Row noVerticalPadding marginBottom={spacing.base} marginTop={spacing.extraLarge}>
                {this.renderRuleTypeIABEntry(RuleExceptionTab, disabled, selectedRowIdx)}
              </Row>
            )}
          </Rows>
        </Dialog>
      );
    }

    renderAllowedCreatives = (): React.ReactNode => {
      const listTableColumns: IListTableColumn[] = [
        {
          field: 'CreativeURL',
          title: '',
          renderType: 'playCreativeURL',
          searchable: false,
          textAlign: 'center',
          textAlignHeader: 'center',
          width: '80px',
        },
        {
          field: 'CreativeURL',
          title: ct('CreativeURL'),
          renderType: 'creativeURL',
          searchable: true,
          textAlign: 'left',
          textAlignHeader: 'left',
          width: '50%',
          cellStyle: {
            wordBreak: 'break-word',
          },
        },
        {
          field: 'Adomain',
          title: ct('Adomain'),
          renderType: 'normal',
          searchable: true,
          textAlign: 'left',
          textAlignHeader: 'left',
        },
        {
          field: 'IABCategory',
          title: ct('IABCategory'),
          renderType: 'normal',
          searchable: true,
          textAlign: 'left',
          textAlignHeader: 'left',
          cellStyle: {
            wordBreak: 'break-word',
          },
        },
      ];

      return (
        <Rows largeVerticalPadding extraLargeHorizontalPadding>
          <Row>
            <ListTable
              title=''
              resource='creative_validation'
              columns={listTableColumns}
              data={this.state.allowedCreativeValidations}
              loading={this.state.loadingCreativeValidations}
              fixedEnabled={true}
              enablePagination={true}
              pageSize={25}
              pageSizeOptions={[10, 25]}
              readRoleName={'read_channel_brandsafety_rule'}
              writeRoleName={'read_channel_brandsafety_rule'}
            />
          </Row>
        </Rows>
      );
    };

    renderBidderSelector(): ReactElement {
      const { BrandSafetyRuleExceptions, headerBidders, openBidderSelectTable, selectedRowIdx } =
        this.state;

      const exceptionTargettedBidderIDs: string[] =
        selectedRowIdx === undefined
          ? []
          : BrandSafetyRuleExceptions[selectedRowIdx]?.BidderIDs?.split(',');

      return (
        <Dialog
          fullWidth
          maxWidth='sm'
          open={openBidderSelectTable}
          onClose={() => this.setState({ openBidderSelectTable: false })}
        >
          <ModalSelectTable
            title={ct('Bidders')}
            items={headerBidders.filter(
              (bidder: IHeaderBidder) => exceptionTargettedBidderIDs?.includes(bidder.ID),
            )}
            onSelectRow={(bidderID: string) => {
              this.setState(
                {
                  openBidderSelectTable: false,
                },
                () => {
                  navigate(RouteBidderSettingsExisting, extractRouteParams(this.props), {
                    b: bidderID,
                  });
                },
              );
            }}
            interactive={true}
          />
        </Dialog>
      );
    }

    // ############################## MAIN RENDER ##############################
    render(): ReactElement {
      const enableExceptions =
        (this.state.ruleType === RuleTypeAdomain || this.state.ruleType === RuleTypeIAB) &&
        (this.state.RuleTargetingType === BrandSafetyRuleTargetingTypeChannel ||
          this.state.RuleTargetingType === BrandSafetyRuleTargetingTypeChannelGroup);

      return (
        <Panels maxWidth vertical relative minWidthMain>
          <Panel largeHorizontalPadding smallVerticalPadding>
            <TopBar title={ct('BrandSafetyRule')} />
          </Panel>

          <Panel>{this.renderTopBar()}</Panel>

          <Panel>
            <SimpleTabs
              activeTabIndex={this.state.activeTabIndex}
              ariaLabel='Brand Safety Rules'
              handleChangeTab={(_event: React.SyntheticEvent, index: number) => {
                this.setState({
                  activeTabIndex: index,
                });
              }}
              tabs={getRuleNavigationConfig(enableExceptions).tabs}
            />
          </Panel>

          <Panel
            flex
            noHorizontalPadding
            paddingTop={spacing.none}
            paddingBottom={spacing.huge}
            scroll
          >
            <SimpleTabSections
              activeTabIndex={this.state.activeTabIndex}
              sections={
                enableExceptions
                  ? [
                      this.renderRuleTargetingTab(),
                      this.renderRuleExceptionsTab(),
                      this.renderAllowedCreatives(),
                    ]
                  : [this.renderRuleTargetingTab(), this.renderAllowedCreatives()]
              }
            />
          </Panel>

          {/* SNACKBAR (for notifications)*/}
          <SnackbarView
            open={!!this.state.snackbarMessage}
            error={this.state.snackbarError}
            onClose={this.snackbarClose}
          >
            {this.state.snackbarMessage}
          </SnackbarView>
        </Panels>
      );
    }
  },
);
